// document.addEventListener('DOMContentLoaded', function () {
//   // Ініціалізація AOS (якщо вона там є, або перенесіть її сюди, щоб керувати порядком)
//   // Якщо AOS.init() виконується в HTML, залиште тут тільки вашу логіку IntersectionObserver
//   // Затримка для гарантованого коректного монтування
//   setTimeout(() => {
//     // Ініціалізація Splide
//     new Splide('#slider1').mount();
//     new Splide('#slider2').mount();
//     new Splide('#slider3').mount(); // Ваш проблемний слайдер
//   }, 100); // Невелика затримка (100 мс) гарантує, що всі скрипти виконано
// });
// document.addEventListener('DOMContentLoaded', function () {
//   // Ініціалізація першого слайдера
//   new Splide('#slider1', {
//     // Додаткові опції, якщо потрібні
//     // наприклад: perPage: 1, rewind: true,
//   }).mount();
//   // Ініціалізація другого слайдера
//   new Splide('#slider2', {
//     // Додаткові опції, якщо потрібні
//   }).mount();
//   // Ініціалізація третього слайдера
//   new Splide('#slider3', {
//     // Додаткові опції, якщо потрібні
//     // Оскільки тут лише 2 слайди, Splide за замовчуванням може вимкнути стрілки,
//     // але пагінація має відображатися правильно.
//   }).mount();
// });
// Щоб анімація була послудовною AOS
function $2cd9b892908a0c8c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2cd9b892908a0c8c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2cd9b892908a0c8c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2cd9b892908a0c8c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $2cd9b892908a0c8c$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $2cd9b892908a0c8c$var$CREATED = 1;
var $2cd9b892908a0c8c$var$MOUNTED = 2;
var $2cd9b892908a0c8c$var$IDLE = 3;
var $2cd9b892908a0c8c$var$MOVING = 4;
var $2cd9b892908a0c8c$var$SCROLLING = 5;
var $2cd9b892908a0c8c$var$DRAGGING = 6;
var $2cd9b892908a0c8c$var$DESTROYED = 7;
var $2cd9b892908a0c8c$var$STATES = {
    CREATED: $2cd9b892908a0c8c$var$CREATED,
    MOUNTED: $2cd9b892908a0c8c$var$MOUNTED,
    IDLE: $2cd9b892908a0c8c$var$IDLE,
    MOVING: $2cd9b892908a0c8c$var$MOVING,
    SCROLLING: $2cd9b892908a0c8c$var$SCROLLING,
    DRAGGING: $2cd9b892908a0c8c$var$DRAGGING,
    DESTROYED: $2cd9b892908a0c8c$var$DESTROYED
};
function $2cd9b892908a0c8c$var$empty(array) {
    array.length = 0;
}
function $2cd9b892908a0c8c$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $2cd9b892908a0c8c$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($2cd9b892908a0c8c$var$slice(arguments, 1)));
}
var $2cd9b892908a0c8c$var$nextTick = setTimeout;
var $2cd9b892908a0c8c$var$noop = function noop() {};
function $2cd9b892908a0c8c$var$raf(func) {
    return requestAnimationFrame(func);
}
function $2cd9b892908a0c8c$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $2cd9b892908a0c8c$var$isObject(subject) {
    return !$2cd9b892908a0c8c$var$isNull(subject) && $2cd9b892908a0c8c$var$typeOf("object", subject);
}
var $2cd9b892908a0c8c$var$isArray = Array.isArray;
var $2cd9b892908a0c8c$var$isFunction = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$typeOf, "function");
var $2cd9b892908a0c8c$var$isString = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$typeOf, "string");
var $2cd9b892908a0c8c$var$isUndefined = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$typeOf, "undefined");
function $2cd9b892908a0c8c$var$isNull(subject) {
    return subject === null;
}
function $2cd9b892908a0c8c$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $2cd9b892908a0c8c$var$toArray(value) {
    return $2cd9b892908a0c8c$var$isArray(value) ? value : [
        value
    ];
}
function $2cd9b892908a0c8c$var$forEach(values, iteratee) {
    $2cd9b892908a0c8c$var$toArray(values).forEach(iteratee);
}
function $2cd9b892908a0c8c$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $2cd9b892908a0c8c$var$push(array, items) {
    array.push.apply(array, $2cd9b892908a0c8c$var$toArray(items));
    return array;
}
function $2cd9b892908a0c8c$var$toggleClass(elm, classes, add) {
    if (elm) $2cd9b892908a0c8c$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $2cd9b892908a0c8c$var$addClass(elm, classes) {
    $2cd9b892908a0c8c$var$toggleClass(elm, $2cd9b892908a0c8c$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $2cd9b892908a0c8c$var$append(parent, children) {
    $2cd9b892908a0c8c$var$forEach(children, parent.appendChild.bind(parent));
}
function $2cd9b892908a0c8c$var$before(nodes, ref) {
    $2cd9b892908a0c8c$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $2cd9b892908a0c8c$var$matches(elm, selector) {
    return $2cd9b892908a0c8c$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $2cd9b892908a0c8c$var$children(parent, selector) {
    var children2 = parent ? $2cd9b892908a0c8c$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $2cd9b892908a0c8c$var$matches(child, selector);
    }) : children2;
}
function $2cd9b892908a0c8c$var$child(parent, selector) {
    return selector ? $2cd9b892908a0c8c$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $2cd9b892908a0c8c$var$ownKeys = Object.keys;
function $2cd9b892908a0c8c$var$forOwn(object, iteratee, right) {
    if (object) (right ? $2cd9b892908a0c8c$var$ownKeys(object).reverse() : $2cd9b892908a0c8c$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $2cd9b892908a0c8c$var$assign(object) {
    $2cd9b892908a0c8c$var$slice(arguments, 1).forEach(function(source) {
        $2cd9b892908a0c8c$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $2cd9b892908a0c8c$var$merge(object) {
    $2cd9b892908a0c8c$var$slice(arguments, 1).forEach(function(source) {
        $2cd9b892908a0c8c$var$forOwn(source, function(value, key) {
            if ($2cd9b892908a0c8c$var$isArray(value)) object[key] = value.slice();
            else if ($2cd9b892908a0c8c$var$isObject(value)) object[key] = $2cd9b892908a0c8c$var$merge({}, $2cd9b892908a0c8c$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $2cd9b892908a0c8c$var$omit(object, keys) {
    $2cd9b892908a0c8c$var$forEach(keys || $2cd9b892908a0c8c$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $2cd9b892908a0c8c$var$removeAttribute(elms, attrs) {
    $2cd9b892908a0c8c$var$forEach(elms, function(elm) {
        $2cd9b892908a0c8c$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $2cd9b892908a0c8c$var$setAttribute(elms, attrs, value) {
    if ($2cd9b892908a0c8c$var$isObject(attrs)) $2cd9b892908a0c8c$var$forOwn(attrs, function(value2, name) {
        $2cd9b892908a0c8c$var$setAttribute(elms, name, value2);
    });
    else $2cd9b892908a0c8c$var$forEach(elms, function(elm) {
        $2cd9b892908a0c8c$var$isNull(value) || value === "" ? $2cd9b892908a0c8c$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $2cd9b892908a0c8c$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $2cd9b892908a0c8c$var$isString(attrs) ? $2cd9b892908a0c8c$var$addClass(elm, attrs) : $2cd9b892908a0c8c$var$setAttribute(elm, attrs);
    parent && $2cd9b892908a0c8c$var$append(parent, elm);
    return elm;
}
function $2cd9b892908a0c8c$var$style(elm, prop, value) {
    if ($2cd9b892908a0c8c$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$2cd9b892908a0c8c$var$isNull(value)) elm.style[prop] = "" + value;
}
function $2cd9b892908a0c8c$var$display(elm, display2) {
    $2cd9b892908a0c8c$var$style(elm, "display", display2);
}
function $2cd9b892908a0c8c$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $2cd9b892908a0c8c$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $2cd9b892908a0c8c$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $2cd9b892908a0c8c$var$rect(target) {
    return target.getBoundingClientRect();
}
function $2cd9b892908a0c8c$var$remove(nodes) {
    $2cd9b892908a0c8c$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $2cd9b892908a0c8c$var$parseHtml(html) {
    return $2cd9b892908a0c8c$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $2cd9b892908a0c8c$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $2cd9b892908a0c8c$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $2cd9b892908a0c8c$var$queryAll(parent, selector) {
    return selector ? $2cd9b892908a0c8c$var$slice(parent.querySelectorAll(selector)) : [];
}
function $2cd9b892908a0c8c$var$removeClass(elm, classes) {
    $2cd9b892908a0c8c$var$toggleClass(elm, classes, false);
}
function $2cd9b892908a0c8c$var$timeOf(e) {
    return e.timeStamp;
}
function $2cd9b892908a0c8c$var$unit(value) {
    return $2cd9b892908a0c8c$var$isString(value) ? value : value ? value + "px" : "";
}
var $2cd9b892908a0c8c$var$PROJECT_CODE = "splide";
var $2cd9b892908a0c8c$var$DATA_ATTRIBUTE = "data-" + $2cd9b892908a0c8c$var$PROJECT_CODE;
function $2cd9b892908a0c8c$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $2cd9b892908a0c8c$var$PROJECT_CODE + "] " + (message || ""));
}
var $2cd9b892908a0c8c$var$min = Math.min, $2cd9b892908a0c8c$var$max = Math.max, $2cd9b892908a0c8c$var$floor = Math.floor, $2cd9b892908a0c8c$var$ceil = Math.ceil, $2cd9b892908a0c8c$var$abs = Math.abs;
function $2cd9b892908a0c8c$var$approximatelyEqual(x, y, epsilon) {
    return $2cd9b892908a0c8c$var$abs(x - y) < epsilon;
}
function $2cd9b892908a0c8c$var$between(number, x, y, exclusive) {
    var minimum = $2cd9b892908a0c8c$var$min(x, y);
    var maximum = $2cd9b892908a0c8c$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $2cd9b892908a0c8c$var$clamp(number, x, y) {
    var minimum = $2cd9b892908a0c8c$var$min(x, y);
    var maximum = $2cd9b892908a0c8c$var$max(x, y);
    return $2cd9b892908a0c8c$var$min($2cd9b892908a0c8c$var$max(minimum, number), maximum);
}
function $2cd9b892908a0c8c$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $2cd9b892908a0c8c$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $2cd9b892908a0c8c$var$format(string, replacements) {
    $2cd9b892908a0c8c$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $2cd9b892908a0c8c$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $2cd9b892908a0c8c$var$ids = {};
function $2cd9b892908a0c8c$var$uniqueId(prefix) {
    return "" + prefix + $2cd9b892908a0c8c$var$pad($2cd9b892908a0c8c$var$ids[prefix] = ($2cd9b892908a0c8c$var$ids[prefix] || 0) + 1);
}
function $2cd9b892908a0c8c$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $2cd9b892908a0c8c$var$forEach(targets, function(target) {
            target && $2cd9b892908a0c8c$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $2cd9b892908a0c8c$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $2cd9b892908a0c8c$export$d300dc1a2634364b = "mounted";
var $2cd9b892908a0c8c$export$d8dac49b4532735a = "ready";
var $2cd9b892908a0c8c$export$2aa493d7c3275167 = "move";
var $2cd9b892908a0c8c$export$fe5802204b967f0d = "moved";
var $2cd9b892908a0c8c$export$5adb665701eda1ce = "click";
var $2cd9b892908a0c8c$export$92e3eae133acac4c = "active";
var $2cd9b892908a0c8c$export$6bcbb81035c12cea = "inactive";
var $2cd9b892908a0c8c$export$6a5b3445e4066a53 = "visible";
var $2cd9b892908a0c8c$export$8c5c7a21d54563e9 = "hidden";
var $2cd9b892908a0c8c$export$7f4701ac5e05e39f = "refresh";
var $2cd9b892908a0c8c$export$db40ab7c0855fa5c = "updated";
var $2cd9b892908a0c8c$export$7e019dae5103a285 = "resize";
var $2cd9b892908a0c8c$export$d637eba1e9e28482 = "resized";
var $2cd9b892908a0c8c$export$e84bf5065c9087ac = "drag";
var $2cd9b892908a0c8c$export$8e9f636d2c722196 = "dragging";
var $2cd9b892908a0c8c$export$90ea576bd3fdeb60 = "dragged";
var $2cd9b892908a0c8c$export$49801896908b5e33 = "scroll";
var $2cd9b892908a0c8c$export$ff8164bff3202b9 = "scrolled";
var $2cd9b892908a0c8c$export$6cbac5b662a31e1b = "overflow";
var $2cd9b892908a0c8c$export$88c4cf7419e470cd = "destroy";
var $2cd9b892908a0c8c$export$8647f6b043e04e9d = "arrows:mounted";
var $2cd9b892908a0c8c$export$d467f9343b961f75 = "arrows:updated";
var $2cd9b892908a0c8c$export$bf89a4e4349c9778 = "pagination:mounted";
var $2cd9b892908a0c8c$export$eb2019082ed6de0b = "pagination:updated";
var $2cd9b892908a0c8c$export$84015c33508f94ec = "navigation:mounted";
var $2cd9b892908a0c8c$export$23663268a31b79e2 = "autoplay:play";
var $2cd9b892908a0c8c$export$185723258309b608 = "autoplay:playing";
var $2cd9b892908a0c8c$export$16a1e4f3d0368265 = "autoplay:pause";
var $2cd9b892908a0c8c$export$9f64346e17f0ec8e = "lazyload:loaded";
var $2cd9b892908a0c8c$export$6d5af59619d10e6a = "sk";
var $2cd9b892908a0c8c$export$f0af896383d5adff = "sh";
var $2cd9b892908a0c8c$export$28dea85f216954dc = "ei";
function $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $2cd9b892908a0c8c$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $2cd9b892908a0c8c$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $2cd9b892908a0c8c$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $2cd9b892908a0c8c$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($2cd9b892908a0c8c$export$88c4cf7419e470cd, binder.destroy);
    return $2cd9b892908a0c8c$var$assign(binder, {
        bus: bus,
        on: on,
        off: $2cd9b892908a0c8c$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $2cd9b892908a0c8c$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $2cd9b892908a0c8c$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $2cd9b892908a0c8c$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $2cd9b892908a0c8c$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $2cd9b892908a0c8c$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $2cd9b892908a0c8c$var$includes($2cd9b892908a0c8c$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $2cd9b892908a0c8c$export$efff0f5979573c99(func, duration) {
    var interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $2cd9b892908a0c8c$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $2cd9b892908a0c8c$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $2cd9b892908a0c8c$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $2cd9b892908a0c8c$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($2cd9b892908a0c8c$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $2cd9b892908a0c8c$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $2cd9b892908a0c8c$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($2cd9b892908a0c8c$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $2cd9b892908a0c8c$var$merge(options, reducedMotion) : $2cd9b892908a0c8c$var$omit(options, $2cd9b892908a0c8c$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $2cd9b892908a0c8c$var$merge(options, opts);
        base && $2cd9b892908a0c8c$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($2cd9b892908a0c8c$var$CREATED)) Splide2.emit($2cd9b892908a0c8c$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $2cd9b892908a0c8c$var$ARROW = "Arrow";
var $2cd9b892908a0c8c$var$ARROW_LEFT = $2cd9b892908a0c8c$var$ARROW + "Left";
var $2cd9b892908a0c8c$var$ARROW_RIGHT = $2cd9b892908a0c8c$var$ARROW + "Right";
var $2cd9b892908a0c8c$var$ARROW_UP = $2cd9b892908a0c8c$var$ARROW + "Up";
var $2cd9b892908a0c8c$var$ARROW_DOWN = $2cd9b892908a0c8c$var$ARROW + "Down";
var $2cd9b892908a0c8c$export$373e92e0788ff06e = "ltr";
var $2cd9b892908a0c8c$export$850f7749a2909601 = "rtl";
var $2cd9b892908a0c8c$export$97170d9824b89709 = "ttb";
var $2cd9b892908a0c8c$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $2cd9b892908a0c8c$var$ARROW_UP,
        $2cd9b892908a0c8c$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $2cd9b892908a0c8c$var$ARROW_DOWN,
        $2cd9b892908a0c8c$var$ARROW_LEFT
    ]
};
function $2cd9b892908a0c8c$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $2cd9b892908a0c8c$export$850f7749a2909601 && !axisOnly ? 1 : direction === $2cd9b892908a0c8c$export$97170d9824b89709 ? 0 : -1;
        return $2cd9b892908a0c8c$var$ORIENTATION_MAP[prop] && $2cd9b892908a0c8c$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $2cd9b892908a0c8c$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $2cd9b892908a0c8c$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $2cd9b892908a0c8c$var$ROLE = "role";
var $2cd9b892908a0c8c$var$TAB_INDEX = "tabindex";
var $2cd9b892908a0c8c$var$DISABLED = "disabled";
var $2cd9b892908a0c8c$var$ARIA_PREFIX = "aria-";
var $2cd9b892908a0c8c$var$ARIA_CONTROLS = $2cd9b892908a0c8c$var$ARIA_PREFIX + "controls";
var $2cd9b892908a0c8c$var$ARIA_CURRENT = $2cd9b892908a0c8c$var$ARIA_PREFIX + "current";
var $2cd9b892908a0c8c$var$ARIA_SELECTED = $2cd9b892908a0c8c$var$ARIA_PREFIX + "selected";
var $2cd9b892908a0c8c$var$ARIA_LABEL = $2cd9b892908a0c8c$var$ARIA_PREFIX + "label";
var $2cd9b892908a0c8c$var$ARIA_LABELLEDBY = $2cd9b892908a0c8c$var$ARIA_PREFIX + "labelledby";
var $2cd9b892908a0c8c$var$ARIA_HIDDEN = $2cd9b892908a0c8c$var$ARIA_PREFIX + "hidden";
var $2cd9b892908a0c8c$var$ARIA_ORIENTATION = $2cd9b892908a0c8c$var$ARIA_PREFIX + "orientation";
var $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION = $2cd9b892908a0c8c$var$ARIA_PREFIX + "roledescription";
var $2cd9b892908a0c8c$var$ARIA_LIVE = $2cd9b892908a0c8c$var$ARIA_PREFIX + "live";
var $2cd9b892908a0c8c$var$ARIA_BUSY = $2cd9b892908a0c8c$var$ARIA_PREFIX + "busy";
var $2cd9b892908a0c8c$var$ARIA_ATOMIC = $2cd9b892908a0c8c$var$ARIA_PREFIX + "atomic";
var $2cd9b892908a0c8c$var$ALL_ATTRIBUTES = [
    $2cd9b892908a0c8c$var$ROLE,
    $2cd9b892908a0c8c$var$TAB_INDEX,
    $2cd9b892908a0c8c$var$DISABLED,
    $2cd9b892908a0c8c$var$ARIA_CONTROLS,
    $2cd9b892908a0c8c$var$ARIA_CURRENT,
    $2cd9b892908a0c8c$var$ARIA_LABEL,
    $2cd9b892908a0c8c$var$ARIA_LABELLEDBY,
    $2cd9b892908a0c8c$var$ARIA_HIDDEN,
    $2cd9b892908a0c8c$var$ARIA_ORIENTATION,
    $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION
];
var $2cd9b892908a0c8c$var$CLASS_PREFIX = $2cd9b892908a0c8c$var$PROJECT_CODE + "__";
var $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX = "is-";
var $2cd9b892908a0c8c$export$93b21159ad85c843 = $2cd9b892908a0c8c$var$PROJECT_CODE;
var $2cd9b892908a0c8c$export$7738b09ac0a98952 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "track";
var $2cd9b892908a0c8c$export$19cc2a5451235cae = $2cd9b892908a0c8c$var$CLASS_PREFIX + "list";
var $2cd9b892908a0c8c$export$8d922915837a38d3 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "slide";
var $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947 = $2cd9b892908a0c8c$export$8d922915837a38d3 + "--clone";
var $2cd9b892908a0c8c$export$e9ba7e444ba60a12 = $2cd9b892908a0c8c$export$8d922915837a38d3 + "__container";
var $2cd9b892908a0c8c$export$a26cbd955fecf11e = $2cd9b892908a0c8c$var$CLASS_PREFIX + "arrows";
var $2cd9b892908a0c8c$export$516e7d18e13a2dca = $2cd9b892908a0c8c$var$CLASS_PREFIX + "arrow";
var $2cd9b892908a0c8c$export$58ea3db24c33b76 = $2cd9b892908a0c8c$export$516e7d18e13a2dca + "--prev";
var $2cd9b892908a0c8c$export$4885afd7098a65c2 = $2cd9b892908a0c8c$export$516e7d18e13a2dca + "--next";
var $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "pagination";
var $2cd9b892908a0c8c$export$52f2cca6a5eee805 = $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3 + "__page";
var $2cd9b892908a0c8c$export$4c82dc32b1c4ace5 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "progress";
var $2cd9b892908a0c8c$export$2c9b091c749f4409 = $2cd9b892908a0c8c$export$4c82dc32b1c4ace5 + "__bar";
var $2cd9b892908a0c8c$export$a29701deef84b825 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "toggle";
var $2cd9b892908a0c8c$export$d9d247d51b430dbb = $2cd9b892908a0c8c$export$a29701deef84b825 + "__play";
var $2cd9b892908a0c8c$export$3529f201a419925b = $2cd9b892908a0c8c$export$a29701deef84b825 + "__pause";
var $2cd9b892908a0c8c$export$3e5381ee3fab8374 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "spinner";
var $2cd9b892908a0c8c$export$bb78d7c200da8960 = $2cd9b892908a0c8c$var$CLASS_PREFIX + "sr";
var $2cd9b892908a0c8c$export$7761661e2d5b9388 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "initialized";
var $2cd9b892908a0c8c$export$72d36ecf3758cb4b = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "active";
var $2cd9b892908a0c8c$export$e423ac4972f5e196 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "prev";
var $2cd9b892908a0c8c$export$457a2d20827a2779 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "next";
var $2cd9b892908a0c8c$export$53ca4621bbab9a = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "visible";
var $2cd9b892908a0c8c$export$d22ec4ccb7996ba2 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "loading";
var $2cd9b892908a0c8c$export$b6f202a162a09100 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "focus-in";
var $2cd9b892908a0c8c$export$cd908cd1dd625e29 = $2cd9b892908a0c8c$var$STATUS_CLASS_PREFIX + "overflow";
var $2cd9b892908a0c8c$export$49f9eaea10ebf193 = [
    $2cd9b892908a0c8c$export$72d36ecf3758cb4b,
    $2cd9b892908a0c8c$export$53ca4621bbab9a,
    $2cd9b892908a0c8c$export$e423ac4972f5e196,
    $2cd9b892908a0c8c$export$457a2d20827a2779,
    $2cd9b892908a0c8c$export$d22ec4ccb7996ba2,
    $2cd9b892908a0c8c$export$b6f202a162a09100,
    $2cd9b892908a0c8c$export$cd908cd1dd625e29
];
var $2cd9b892908a0c8c$export$ba41d43e4a419565 = {
    slide: $2cd9b892908a0c8c$export$8d922915837a38d3,
    clone: $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947,
    arrows: $2cd9b892908a0c8c$export$a26cbd955fecf11e,
    arrow: $2cd9b892908a0c8c$export$516e7d18e13a2dca,
    prev: $2cd9b892908a0c8c$export$58ea3db24c33b76,
    next: $2cd9b892908a0c8c$export$4885afd7098a65c2,
    pagination: $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3,
    page: $2cd9b892908a0c8c$export$52f2cca6a5eee805,
    spinner: $2cd9b892908a0c8c$export$3e5381ee3fab8374
};
function $2cd9b892908a0c8c$var$closest(from, selector) {
    if ($2cd9b892908a0c8c$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($2cd9b892908a0c8c$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $2cd9b892908a0c8c$var$FRICTION = 5;
var $2cd9b892908a0c8c$var$LOG_INTERVAL = 200;
var $2cd9b892908a0c8c$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $2cd9b892908a0c8c$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $2cd9b892908a0c8c$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, destroy);
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, setup);
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, update);
        bind(document, $2cd9b892908a0c8c$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $2cd9b892908a0c8c$var$toggleClass(root, $2cd9b892908a0c8c$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $2cd9b892908a0c8c$var$ALL_ATTRIBUTES.concat("style");
        $2cd9b892908a0c8c$var$empty(slides);
        $2cd9b892908a0c8c$var$removeClass(root, rootClasses);
        $2cd9b892908a0c8c$var$removeClass(track, trackClasses);
        $2cd9b892908a0c8c$var$removeAttribute([
            track,
            list
        ], attrs);
        $2cd9b892908a0c8c$var$removeAttribute(root, completely ? attrs : [
            "style",
            $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $2cd9b892908a0c8c$var$removeClass(root, rootClasses);
        $2cd9b892908a0c8c$var$removeClass(track, trackClasses);
        rootClasses = getClasses($2cd9b892908a0c8c$export$93b21159ad85c843);
        trackClasses = getClasses($2cd9b892908a0c8c$export$7738b09ac0a98952);
        $2cd9b892908a0c8c$var$addClass(root, rootClasses);
        $2cd9b892908a0c8c$var$addClass(track, trackClasses);
        $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABEL, options.label);
        $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $2cd9b892908a0c8c$export$7738b09ac0a98952);
        list = $2cd9b892908a0c8c$var$child(track, "." + $2cd9b892908a0c8c$export$19cc2a5451235cae);
        $2cd9b892908a0c8c$var$assert(track && list, "A track/list element is missing.");
        $2cd9b892908a0c8c$var$push(slides, $2cd9b892908a0c8c$var$children(list, "." + $2cd9b892908a0c8c$export$8d922915837a38d3 + ":not(." + $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947 + ")"));
        $2cd9b892908a0c8c$var$forOwn({
            arrows: $2cd9b892908a0c8c$export$a26cbd955fecf11e,
            pagination: $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3,
            prev: $2cd9b892908a0c8c$export$58ea3db24c33b76,
            next: $2cd9b892908a0c8c$export$4885afd7098a65c2,
            bar: $2cd9b892908a0c8c$export$2c9b091c749f4409,
            toggle: $2cd9b892908a0c8c$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $2cd9b892908a0c8c$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $2cd9b892908a0c8c$var$uniqueId($2cd9b892908a0c8c$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$ROLE) && root.tagName !== "SECTION" && role) $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ROLE, role);
        $2cd9b892908a0c8c$var$setAttribute(root, $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $2cd9b892908a0c8c$var$query(root, selector);
        return elm && $2cd9b892908a0c8c$var$closest(elm, "." + $2cd9b892908a0c8c$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $2cd9b892908a0c8c$export$93b21159ad85c843 && $2cd9b892908a0c8c$export$72d36ecf3758cb4b
        ];
    }
    return $2cd9b892908a0c8c$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $2cd9b892908a0c8c$export$e5a58a5ee5b54c22 = "slide";
var $2cd9b892908a0c8c$export$f42383286ed1223d = "loop";
var $2cd9b892908a0c8c$export$742b62a5690c060 = "fade";
function $2cd9b892908a0c8c$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $2cd9b892908a0c8c$var$getAttribute(slide, "style");
    var label = $2cd9b892908a0c8c$var$getAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $2cd9b892908a0c8c$var$child(slide, "." + $2cd9b892908a0c8c$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $2cd9b892908a0c8c$var$pad(index + 1);
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ROLE, pagination ? "tabpanel" : "group");
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL, label || $2cd9b892908a0c8c$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$6d5af59619d10e6a, self));
        on([
            $2cd9b892908a0c8c$export$fe5802204b967f0d,
            $2cd9b892908a0c8c$export$f0af896383d5adff,
            $2cd9b892908a0c8c$export$ff8164bff3202b9
        ], update);
        on($2cd9b892908a0c8c$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($2cd9b892908a0c8c$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $2cd9b892908a0c8c$var$removeClass(slide, $2cd9b892908a0c8c$export$49f9eaea10ebf193);
        $2cd9b892908a0c8c$var$removeAttribute(slide, $2cd9b892908a0c8c$var$ALL_ATTRIBUTES);
        $2cd9b892908a0c8c$var$setAttribute(slide, "style", styles);
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_LABEL, $2cd9b892908a0c8c$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_CONTROLS, controls);
        $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $2cd9b892908a0c8c$var$removeAttribute(slide, $2cd9b892908a0c8c$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$e423ac4972f5e196, index === curr - 1);
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $2cd9b892908a0c8c$var$hasClass(slide, $2cd9b892908a0c8c$export$72d36ecf3758cb4b)) {
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$72d36ecf3758cb4b, active);
            $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $2cd9b892908a0c8c$export$92e3eae133acac4c : $2cd9b892908a0c8c$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $2cd9b892908a0c8c$var$MOVING,
            $2cd9b892908a0c8c$var$SCROLLING
        ])) $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$ARIA_HIDDEN, hidden || "");
        $2cd9b892908a0c8c$var$setAttribute($2cd9b892908a0c8c$var$queryAll(slide, options.focusableNodes || ""), $2cd9b892908a0c8c$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $2cd9b892908a0c8c$var$setAttribute(slide, $2cd9b892908a0c8c$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $2cd9b892908a0c8c$var$hasClass(slide, $2cd9b892908a0c8c$export$53ca4621bbab9a)) {
            $2cd9b892908a0c8c$var$toggleClass(slide, $2cd9b892908a0c8c$export$53ca4621bbab9a, visible);
            emit(visible ? $2cd9b892908a0c8c$export$6a5b3445e4066a53 : $2cd9b892908a0c8c$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $2cd9b892908a0c8c$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $2cd9b892908a0c8c$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060)) return isActive();
        var trackRect = $2cd9b892908a0c8c$var$rect(Components.Elements.track);
        var slideRect = $2cd9b892908a0c8c$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $2cd9b892908a0c8c$var$floor(trackRect[left]) <= $2cd9b892908a0c8c$var$ceil(slideRect[left]) && $2cd9b892908a0c8c$var$floor(slideRect[right]) <= $2cd9b892908a0c8c$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $2cd9b892908a0c8c$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d))) diff = $2cd9b892908a0c8c$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $2cd9b892908a0c8c$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, destroy);
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $2cd9b892908a0c8c$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $2cd9b892908a0c8c$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $2cd9b892908a0c8c$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $2cd9b892908a0c8c$var$forEach(items, function(slide) {
            if ($2cd9b892908a0c8c$var$isString(slide)) slide = $2cd9b892908a0c8c$var$parseHtml(slide);
            if ($2cd9b892908a0c8c$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $2cd9b892908a0c8c$var$before(slide, ref) : $2cd9b892908a0c8c$var$append(list, slide);
                $2cd9b892908a0c8c$var$addClass(slide, options.classes.slide);
                observeImages(slide, $2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$7e019dae5103a285));
            }
        });
        emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $2cd9b892908a0c8c$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($2cd9b892908a0c8c$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $2cd9b892908a0c8c$var$isString(matcher) ? $2cd9b892908a0c8c$var$matches(Slide2.slide, matcher) : $2cd9b892908a0c8c$var$includes($2cd9b892908a0c8c$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $2cd9b892908a0c8c$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $2cd9b892908a0c8c$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $2cd9b892908a0c8c$export$efff0f5979573c99($2cd9b892908a0c8c$var$apply(emit, $2cd9b892908a0c8c$export$7e019dae5103a285)));
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], init);
        on($2cd9b892908a0c8c$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $2cd9b892908a0c8c$export$97170d9824b89709;
        $2cd9b892908a0c8c$var$style(root, "maxWidth", $2cd9b892908a0c8c$var$unit(options.width));
        $2cd9b892908a0c8c$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $2cd9b892908a0c8c$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $2cd9b892908a0c8c$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $2cd9b892908a0c8c$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $2cd9b892908a0c8c$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($2cd9b892908a0c8c$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $2cd9b892908a0c8c$var$toggleClass(root, $2cd9b892908a0c8c$export$cd908cd1dd625e29, overflow);
                emit($2cd9b892908a0c8c$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $2cd9b892908a0c8c$var$unit(padding[prop] || ($2cd9b892908a0c8c$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $2cd9b892908a0c8c$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $2cd9b892908a0c8c$var$unit(options.height || $2cd9b892908a0c8c$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $2cd9b892908a0c8c$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $2cd9b892908a0c8c$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $2cd9b892908a0c8c$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $2cd9b892908a0c8c$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $2cd9b892908a0c8c$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $2cd9b892908a0c8c$var$rect(Slide.slide)[resolve("right")];
            var left = $2cd9b892908a0c8c$var$rect(list)[resolve("left")];
            return $2cd9b892908a0c8c$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($2cd9b892908a0c8c$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($2cd9b892908a0c8c$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $2cd9b892908a0c8c$var$MULTIPLIER = 2;
function $2cd9b892908a0c8c$var$Clones(Splide2, Components2, options) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, remount);
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $2cd9b892908a0c8c$var$remove(clones);
        $2cd9b892908a0c8c$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$2cd9b892908a0c8c$var$push(slides, slides);
            $2cd9b892908a0c8c$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $2cd9b892908a0c8c$var$before(clone, slides[0].slide) : $2cd9b892908a0c8c$var$append(Elements.list, clone);
                $2cd9b892908a0c8c$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $2cd9b892908a0c8c$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $2cd9b892908a0c8c$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d)) clones2 = 0;
        else if ($2cd9b892908a0c8c$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $2cd9b892908a0c8c$var$ceil($2cd9b892908a0c8c$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $2cd9b892908a0c8c$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $2cd9b892908a0c8c$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$d637eba1e9e28482,
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($2cd9b892908a0c8c$var$MOVING);
        emit($2cd9b892908a0c8c$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($2cd9b892908a0c8c$var$IDLE);
            emit($2cd9b892908a0c8c$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $2cd9b892908a0c8c$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($2cd9b892908a0c8c$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($2cd9b892908a0c8c$var$ceil($2cd9b892908a0c8c$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $2cd9b892908a0c8c$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $2cd9b892908a0c8c$var$rect(list)[left] - $2cd9b892908a0c8c$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22)) position = $2cd9b892908a0c8c$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $2cd9b892908a0c8c$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $2cd9b892908a0c8c$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $2cd9b892908a0c8c$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d);
    var isSlide = Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22);
    var getNext = $2cd9b892908a0c8c$var$apply(getAdjacent, false);
    var getPrev = $2cd9b892908a0c8c$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f,
            $2cd9b892908a0c8c$export$28dea85f216954dc
        ], init);
        on($2cd9b892908a0c8c$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $2cd9b892908a0c8c$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($2cd9b892908a0c8c$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $2cd9b892908a0c8c$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($2cd9b892908a0c8c$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $2cd9b892908a0c8c$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$2cd9b892908a0c8c$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($2cd9b892908a0c8c$var$between(0, dest, from, true) || $2cd9b892908a0c8c$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $2cd9b892908a0c8c$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $2cd9b892908a0c8c$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $2cd9b892908a0c8c$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $2cd9b892908a0c8c$var$min(index, endIndex) : $2cd9b892908a0c8c$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $2cd9b892908a0c8c$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$2cd9b892908a0c8c$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $2cd9b892908a0c8c$var$MOVING,
            $2cd9b892908a0c8c$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $2cd9b892908a0c8c$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $2cd9b892908a0c8c$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $2cd9b892908a0c8c$var$SIZE = 40;
function $2cd9b892908a0c8c$var$Arrows(Splide2, Components2, options) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $2cd9b892908a0c8c$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $2cd9b892908a0c8c$var$display(wrapper, enabled ? "" : "none");
            $2cd9b892908a0c8c$var$addClass(wrapper, wrapperClasses = $2cd9b892908a0c8c$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $2cd9b892908a0c8c$var$setAttribute([
                    prev,
                    next
                ], $2cd9b892908a0c8c$var$ARIA_CONTROLS, track.id);
                emit($2cd9b892908a0c8c$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $2cd9b892908a0c8c$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $2cd9b892908a0c8c$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $2cd9b892908a0c8c$var$removeAttribute([
            prev,
            next
        ], $2cd9b892908a0c8c$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$fe5802204b967f0d,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f,
            $2cd9b892908a0c8c$export$ff8164bff3202b9,
            $2cd9b892908a0c8c$export$28dea85f216954dc
        ], update);
        bind(next, "click", $2cd9b892908a0c8c$var$apply(go, ">"));
        bind(prev, "click", $2cd9b892908a0c8c$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $2cd9b892908a0c8c$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $2cd9b892908a0c8c$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $2cd9b892908a0c8c$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $2cd9b892908a0c8c$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $2cd9b892908a0c8c$var$SIZE + " " + $2cd9b892908a0c8c$var$SIZE + "\" width=\"" + $2cd9b892908a0c8c$var$SIZE + "\" height=\"" + $2cd9b892908a0c8c$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $2cd9b892908a0c8c$var$PATH) + "\" />";
        return $2cd9b892908a0c8c$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $2cd9b892908a0c8c$var$setAttribute(prev, $2cd9b892908a0c8c$var$ARIA_LABEL, prevLabel);
            $2cd9b892908a0c8c$var$setAttribute(next, $2cd9b892908a0c8c$var$ARIA_LABEL, nextLabel);
            emit($2cd9b892908a0c8c$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $2cd9b892908a0c8c$var$INTERVAL_DATA_ATTRIBUTE = $2cd9b892908a0c8c$var$DATA_ATTRIBUTE + "-interval";
function $2cd9b892908a0c8c$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $2cd9b892908a0c8c$var$setAttribute(toggle, $2cd9b892908a0c8c$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $2cd9b892908a0c8c$export$2aa493d7c3275167,
            $2cd9b892908a0c8c$export$49801896908b5e33,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($2cd9b892908a0c8c$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($2cd9b892908a0c8c$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($2cd9b892908a0c8c$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $2cd9b892908a0c8c$var$toggleClass(toggle, $2cd9b892908a0c8c$export$72d36ecf3758cb4b, !stopped);
            $2cd9b892908a0c8c$var$setAttribute(toggle, $2cd9b892908a0c8c$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $2cd9b892908a0c8c$var$style(bar, "width", rate * 100 + "%");
        emit($2cd9b892908a0c8c$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$2cd9b892908a0c8c$var$getAttribute(Slide.slide, $2cd9b892908a0c8c$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $2cd9b892908a0c8c$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($2cd9b892908a0c8c$export$9f64346e17f0ec8e, $2cd9b892908a0c8c$var$apply(toggle, true));
            on([
                $2cd9b892908a0c8c$export$d300dc1a2634364b,
                $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
                $2cd9b892908a0c8c$export$7f4701ac5e05e39f
            ], $2cd9b892908a0c8c$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $2cd9b892908a0c8c$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $2cd9b892908a0c8c$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $2cd9b892908a0c8c$var$apply(cover, false)
    };
}
var $2cd9b892908a0c8c$var$BOUNCE_DIFF_THRESHOLD = 10;
var $2cd9b892908a0c8c$var$BOUNCE_DURATION = 600;
var $2cd9b892908a0c8c$var$FRICTION_FACTOR = 0.6;
var $2cd9b892908a0c8c$var$BASE_VELOCITY = 1.5;
var $2cd9b892908a0c8c$var$MIN_DURATION = 800;
function $2cd9b892908a0c8c$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($2cd9b892908a0c8c$export$2aa493d7c3275167, clear);
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $2cd9b892908a0c8c$var$sign(destination) * size * $2cd9b892908a0c8c$var$floor($2cd9b892908a0c8c$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $2cd9b892908a0c8c$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $2cd9b892908a0c8c$var$max($2cd9b892908a0c8c$var$abs(destination - from) / $2cd9b892908a0c8c$var$BASE_VELOCITY, $2cd9b892908a0c8c$var$MIN_DURATION);
        callback = onScrolled;
        interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0(duration, onEnd, $2cd9b892908a0c8c$var$apply(update, from, destination, noConstrain), 1);
        set($2cd9b892908a0c8c$var$SCROLLING);
        emit($2cd9b892908a0c8c$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($2cd9b892908a0c8c$var$IDLE);
        callback && callback();
        emit($2cd9b892908a0c8c$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $2cd9b892908a0c8c$var$FRICTION_FACTOR;
            if ($2cd9b892908a0c8c$var$abs(diff) < $2cd9b892908a0c8c$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $2cd9b892908a0c8c$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $2cd9b892908a0c8c$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS, $2cd9b892908a0c8c$var$noop, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $2cd9b892908a0c8c$var$POINTER_UP_EVENTS, $2cd9b892908a0c8c$var$noop, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $2cd9b892908a0c8c$var$POINTER_DOWN_EVENTS, onPointerDown, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $2cd9b892908a0c8c$var$prevent);
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $2cd9b892908a0c8c$var$MOVING,
                        $2cd9b892908a0c8c$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS, onPointerMove, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $2cd9b892908a0c8c$var$POINTER_UP_EVENTS, onPointerUp, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $2cd9b892908a0c8c$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($2cd9b892908a0c8c$var$DRAGGING)) {
            state.set($2cd9b892908a0c8c$var$DRAGGING);
            emit($2cd9b892908a0c8c$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $2cd9b892908a0c8c$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($2cd9b892908a0c8c$export$8e9f636d2c722196);
                $2cd9b892908a0c8c$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $2cd9b892908a0c8c$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($2cd9b892908a0c8c$var$DRAGGING)) {
            state.set($2cd9b892908a0c8c$var$IDLE);
            emit($2cd9b892908a0c8c$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $2cd9b892908a0c8c$var$prevent(e);
        }
        unbind(target, $2cd9b892908a0c8c$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $2cd9b892908a0c8c$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $2cd9b892908a0c8c$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($2cd9b892908a0c8c$export$742b62a5690c060)) Controller.go(orient($2cd9b892908a0c8c$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $2cd9b892908a0c8c$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $2cd9b892908a0c8c$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $2cd9b892908a0c8c$var$abs(diffCoord(e)) > $2cd9b892908a0c8c$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($2cd9b892908a0c8c$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $2cd9b892908a0c8c$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $2cd9b892908a0c8c$var$sign(velocity) * $2cd9b892908a0c8c$var$min($2cd9b892908a0c8c$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $2cd9b892908a0c8c$var$timeOf(e) - $2cd9b892908a0c8c$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22) ? $2cd9b892908a0c8c$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$2cd9b892908a0c8c$var$matches(target2, "." + $2cd9b892908a0c8c$export$52f2cca6a5eee805 + ", ." + $2cd9b892908a0c8c$export$516e7d18e13a2dca) && (!noDrag || !$2cd9b892908a0c8c$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $2cd9b892908a0c8c$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $2cd9b892908a0c8c$var$ARROW_RIGHT,
    Left: $2cd9b892908a0c8c$var$ARROW_LEFT,
    Up: $2cd9b892908a0c8c$var$ARROW_UP,
    Down: $2cd9b892908a0c8c$var$ARROW_DOWN
};
function $2cd9b892908a0c8c$var$normalizeKey(key) {
    key = $2cd9b892908a0c8c$var$isString(key) ? key : key.key;
    return $2cd9b892908a0c8c$var$NORMALIZATION_MAP[key] || key;
}
var $2cd9b892908a0c8c$var$KEYBOARD_EVENT = "keydown";
function $2cd9b892908a0c8c$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, destroy);
        on($2cd9b892908a0c8c$export$db40ab7c0855fa5c, init);
        on($2cd9b892908a0c8c$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $2cd9b892908a0c8c$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $2cd9b892908a0c8c$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $2cd9b892908a0c8c$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $2cd9b892908a0c8c$var$normalizeKey(e);
            if (key === resolve($2cd9b892908a0c8c$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($2cd9b892908a0c8c$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE = $2cd9b892908a0c8c$var$DATA_ATTRIBUTE + "-lazy";
var $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE = $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $2cd9b892908a0c8c$var$IMAGE_SELECTOR = "[" + $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE + "], [" + $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE + "]";
function $2cd9b892908a0c8c$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $2cd9b892908a0c8c$export$fe5802204b967f0d,
        $2cd9b892908a0c8c$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($2cd9b892908a0c8c$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $2cd9b892908a0c8c$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $2cd9b892908a0c8c$var$queryAll(Slide.slide, $2cd9b892908a0c8c$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE);
                var srcset = $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $2cd9b892908a0c8c$var$child(parent, "." + className) || $2cd9b892908a0c8c$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $2cd9b892908a0c8c$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $2cd9b892908a0c8c$var$addClass(data[1].slide, $2cd9b892908a0c8c$export$d22ec4ccb7996ba2);
        bind(img, "load error", $2cd9b892908a0c8c$var$apply(onLoad, data));
        $2cd9b892908a0c8c$var$setAttribute(img, "src", $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE));
        $2cd9b892908a0c8c$var$setAttribute(img, "srcset", $2cd9b892908a0c8c$var$getAttribute(img, $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE));
        $2cd9b892908a0c8c$var$removeAttribute(img, $2cd9b892908a0c8c$var$SRC_DATA_ATTRIBUTE);
        $2cd9b892908a0c8c$var$removeAttribute(img, $2cd9b892908a0c8c$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $2cd9b892908a0c8c$var$removeClass(Slide.slide, $2cd9b892908a0c8c$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $2cd9b892908a0c8c$var$remove(data[2]);
            $2cd9b892908a0c8c$var$display(img, "");
            emit($2cd9b892908a0c8c$export$9f64346e17f0ec8e, img, Slide);
            emit($2cd9b892908a0c8c$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$empty, entries),
        check: check
    };
}
function $2cd9b892908a0c8c$var$Pagination(Splide2, Components2, options) {
    var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f,
            $2cd9b892908a0c8c$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $2cd9b892908a0c8c$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $2cd9b892908a0c8c$export$2aa493d7c3275167,
                $2cd9b892908a0c8c$export$49801896908b5e33,
                $2cd9b892908a0c8c$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($2cd9b892908a0c8c$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $2cd9b892908a0c8c$var$remove(placeholder ? $2cd9b892908a0c8c$var$slice(list.children) : list);
            $2cd9b892908a0c8c$var$removeClass(list, paginationClasses);
            $2cd9b892908a0c8c$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $2cd9b892908a0c8c$var$ceil(length / perPage);
        list = placeholder || $2cd9b892908a0c8c$var$create("ul", classes.pagination, Elements.track.parentElement);
        $2cd9b892908a0c8c$var$addClass(list, paginationClasses = $2cd9b892908a0c8c$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ROLE, "tablist");
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ARIA_LABEL, i18n.select);
        $2cd9b892908a0c8c$var$setAttribute(list, $2cd9b892908a0c8c$var$ARIA_ORIENTATION, getDirection() === $2cd9b892908a0c8c$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $2cd9b892908a0c8c$var$create("li", null, list);
            var button = $2cd9b892908a0c8c$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $2cd9b892908a0c8c$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $2cd9b892908a0c8c$var$apply(onKeydown, i));
            $2cd9b892908a0c8c$var$setAttribute(li, $2cd9b892908a0c8c$var$ROLE, "presentation");
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$ROLE, "tab");
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$ARIA_CONTROLS, controls.join(" "));
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$ARIA_LABEL, $2cd9b892908a0c8c$var$format(text, i + 1));
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $2cd9b892908a0c8c$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($2cd9b892908a0c8c$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($2cd9b892908a0c8c$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $2cd9b892908a0c8c$var$focus(item.button);
            go(">" + nextPage);
            $2cd9b892908a0c8c$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $2cd9b892908a0c8c$var$removeClass(button, $2cd9b892908a0c8c$export$72d36ecf3758cb4b);
            $2cd9b892908a0c8c$var$removeAttribute(button, $2cd9b892908a0c8c$var$ARIA_SELECTED);
            $2cd9b892908a0c8c$var$setAttribute(button, $2cd9b892908a0c8c$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $2cd9b892908a0c8c$var$addClass(_button, $2cd9b892908a0c8c$export$72d36ecf3758cb4b);
            $2cd9b892908a0c8c$var$setAttribute(_button, $2cd9b892908a0c8c$var$ARIA_SELECTED, true);
            $2cd9b892908a0c8c$var$setAttribute(_button, $2cd9b892908a0c8c$var$TAB_INDEX, "");
        }
        emit($2cd9b892908a0c8c$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $2cd9b892908a0c8c$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $2cd9b892908a0c8c$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $2cd9b892908a0c8c$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(splide);
        event.on($2cd9b892908a0c8c$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($2cd9b892908a0c8c$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($2cd9b892908a0c8c$export$5adb665701eda1ce, onClick);
        on($2cd9b892908a0c8c$export$6d5af59619d10e6a, onKeydown);
        on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($2cd9b892908a0c8c$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $2cd9b892908a0c8c$var$setAttribute(Components2.Elements.list, $2cd9b892908a0c8c$var$ARIA_ORIENTATION, options.direction === $2cd9b892908a0c8c$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($2cd9b892908a0c8c$var$includes($2cd9b892908a0c8c$var$TRIGGER_KEYS, $2cd9b892908a0c8c$var$normalizeKey(e))) {
            onClick(Slide);
            $2cd9b892908a0c8c$var$prevent(e);
        }
    }
    return {
        setup: $2cd9b892908a0c8c$var$apply(Components2.Media.set, {
            slideFocus: $2cd9b892908a0c8c$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $2cd9b892908a0c8c$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $2cd9b892908a0c8c$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $2cd9b892908a0c8c$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($2cd9b892908a0c8c$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $2cd9b892908a0c8c$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($2cd9b892908a0c8c$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $2cd9b892908a0c8c$var$SR_REMOVAL_DELAY = 90;
function $2cd9b892908a0c8c$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $2cd9b892908a0c8c$var$create("span", $2cd9b892908a0c8c$export$bb78d7c200da8960);
    var interval = $2cd9b892908a0c8c$export$46ad21b25b6dccf0($2cd9b892908a0c8c$var$SR_REMOVAL_DELAY, $2cd9b892908a0c8c$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $2cd9b892908a0c8c$var$setAttribute(track, $2cd9b892908a0c8c$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($2cd9b892908a0c8c$export$23663268a31b79e2, $2cd9b892908a0c8c$var$apply(disable, true));
            on($2cd9b892908a0c8c$export$16a1e4f3d0368265, $2cd9b892908a0c8c$var$apply(disable, false));
            on([
                $2cd9b892908a0c8c$export$fe5802204b967f0d,
                $2cd9b892908a0c8c$export$ff8164bff3202b9
            ], $2cd9b892908a0c8c$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $2cd9b892908a0c8c$var$setAttribute(track, $2cd9b892908a0c8c$var$ARIA_BUSY, active);
        if (active) {
            $2cd9b892908a0c8c$var$append(track, sr);
            interval.start();
        } else {
            $2cd9b892908a0c8c$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $2cd9b892908a0c8c$var$removeAttribute(track, [
            $2cd9b892908a0c8c$var$ARIA_LIVE,
            $2cd9b892908a0c8c$var$ARIA_ATOMIC,
            $2cd9b892908a0c8c$var$ARIA_BUSY
        ]);
        $2cd9b892908a0c8c$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $2cd9b892908a0c8c$var$setAttribute(track, $2cd9b892908a0c8c$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $2cd9b892908a0c8c$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $2cd9b892908a0c8c$var$Media,
    Direction: $2cd9b892908a0c8c$var$Direction,
    Elements: $2cd9b892908a0c8c$var$Elements,
    Slides: $2cd9b892908a0c8c$var$Slides,
    Layout: $2cd9b892908a0c8c$var$Layout,
    Clones: $2cd9b892908a0c8c$var$Clones,
    Move: $2cd9b892908a0c8c$var$Move,
    Controller: $2cd9b892908a0c8c$var$Controller,
    Arrows: $2cd9b892908a0c8c$var$Arrows,
    Autoplay: $2cd9b892908a0c8c$var$Autoplay,
    Cover: $2cd9b892908a0c8c$var$Cover,
    Scroll: $2cd9b892908a0c8c$var$Scroll,
    Drag: $2cd9b892908a0c8c$var$Drag,
    Keyboard: $2cd9b892908a0c8c$var$Keyboard,
    LazyLoad: $2cd9b892908a0c8c$var$LazyLoad,
    Pagination: $2cd9b892908a0c8c$var$Pagination,
    Sync: $2cd9b892908a0c8c$var$Sync,
    Wheel: $2cd9b892908a0c8c$var$Wheel,
    Live: $2cd9b892908a0c8c$var$Live
});
var $2cd9b892908a0c8c$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $2cd9b892908a0c8c$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $2cd9b892908a0c8c$export$ba41d43e4a419565,
    i18n: $2cd9b892908a0c8c$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $2cd9b892908a0c8c$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2).on([
            $2cd9b892908a0c8c$export$d300dc1a2634364b,
            $2cd9b892908a0c8c$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $2cd9b892908a0c8c$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $2cd9b892908a0c8c$var$noop
    };
}
function $2cd9b892908a0c8c$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $2cd9b892908a0c8c$var$apply($2cd9b892908a0c8c$var$style, list, "transition");
    var endCallback;
    function mount() {
        $2cd9b892908a0c8c$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($2cd9b892908a0c8c$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($2cd9b892908a0c8c$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $2cd9b892908a0c8c$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $2cd9b892908a0c8c$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $2cd9b892908a0c8c$export$7254cc27399e90bd($2cd9b892908a0c8c$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $2cd9b892908a0c8c$var$isString(target) ? $2cd9b892908a0c8c$var$query(document, target) : target;
        $2cd9b892908a0c8c$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $2cd9b892908a0c8c$var$merge({
            label: $2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABEL) || "",
            labelledby: $2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$ARIA_LABELLEDBY) || ""
        }, $2cd9b892908a0c8c$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $2cd9b892908a0c8c$var$merge(options, JSON.parse($2cd9b892908a0c8c$var$getAttribute(root, $2cd9b892908a0c8c$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $2cd9b892908a0c8c$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($2cd9b892908a0c8c$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $2cd9b892908a0c8c$var$assert(state.is([
            $2cd9b892908a0c8c$var$CREATED,
            $2cd9b892908a0c8c$var$DESTROYED
        ]), "Already mounted!");
        state.set($2cd9b892908a0c8c$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($2cd9b892908a0c8c$export$742b62a5690c060) ? $2cd9b892908a0c8c$var$Fade : $2cd9b892908a0c8c$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $2cd9b892908a0c8c$var$assign({}, $2cd9b892908a0c8c$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $2cd9b892908a0c8c$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $2cd9b892908a0c8c$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($2cd9b892908a0c8c$export$d300dc1a2634364b);
        $2cd9b892908a0c8c$var$addClass(this.root, $2cd9b892908a0c8c$export$7761661e2d5b9388);
        state.set($2cd9b892908a0c8c$var$IDLE);
        this.emit($2cd9b892908a0c8c$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($2cd9b892908a0c8c$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($2cd9b892908a0c8c$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($2cd9b892908a0c8c$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($2cd9b892908a0c8c$var$CREATED)) $2cd9b892908a0c8c$export$f188226459c8a3ff(this).on($2cd9b892908a0c8c$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $2cd9b892908a0c8c$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($2cd9b892908a0c8c$export$88c4cf7419e470cd);
            event.destroy();
            completely && $2cd9b892908a0c8c$var$empty(this.splides);
            state.set($2cd9b892908a0c8c$var$DESTROYED);
        }
        return this;
    };
    $2cd9b892908a0c8c$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $2cd9b892908a0c8c$export$24494c7438c070bf = $2cd9b892908a0c8c$var$_Splide;
$2cd9b892908a0c8c$export$24494c7438c070bf.defaults = {};
$2cd9b892908a0c8c$export$24494c7438c070bf.STATES = $2cd9b892908a0c8c$var$STATES;
var $2cd9b892908a0c8c$var$CLASS_RENDERED = "is-rendered";
var $2cd9b892908a0c8c$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $2cd9b892908a0c8c$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $2cd9b892908a0c8c$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $2cd9b892908a0c8c$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $2cd9b892908a0c8c$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $2cd9b892908a0c8c$var$merge($2cd9b892908a0c8c$export$f484e977a69c6ba6, defaults || {});
        $2cd9b892908a0c8c$var$merge($2cd9b892908a0c8c$var$merge(this.options, $2cd9b892908a0c8c$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $2cd9b892908a0c8c$var$assign({}, $2cd9b892908a0c8c$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $2cd9b892908a0c8c$var$uniqueId("splide");
        this.Style = new $2cd9b892908a0c8c$var$Style(this.id, this.options);
        this.Direction = $2cd9b892908a0c8c$var$Direction(null, null, this.options);
        $2cd9b892908a0c8c$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $2cd9b892908a0c8c$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $2cd9b892908a0c8c$var$queryAll(root, "." + $2cd9b892908a0c8c$export$2c1ba4a4f1aa4947);
        on($2cd9b892908a0c8c$export$d300dc1a2634364b, function() {
            $2cd9b892908a0c8c$var$remove($2cd9b892908a0c8c$var$child(root, "style"));
        });
        $2cd9b892908a0c8c$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $2cd9b892908a0c8c$var$push(this.slides, this.contents.map(function(content, index) {
            content = $2cd9b892908a0c8c$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $2cd9b892908a0c8c$export$72d36ecf3758cb4b : "");
            $2cd9b892908a0c8c$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $2cd9b892908a0c8c$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $2cd9b892908a0c8c$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $2cd9b892908a0c8c$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $2cd9b892908a0c8c$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $2cd9b892908a0c8c$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $2cd9b892908a0c8c$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $2cd9b892908a0c8c$var$unit(padding[prop] || ($2cd9b892908a0c8c$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $2cd9b892908a0c8c$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $2cd9b892908a0c8c$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $2cd9b892908a0c8c$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $2cd9b892908a0c8c$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $2cd9b892908a0c8c$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($2cd9b892908a0c8c$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $2cd9b892908a0c8c$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $2cd9b892908a0c8c$var$merge($2cd9b892908a0c8c$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $2cd9b892908a0c8c$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $2cd9b892908a0c8c$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $2cd9b892908a0c8c$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $2cd9b892908a0c8c$export$93b21159ad85c843,
            $2cd9b892908a0c8c$export$93b21159ad85c843 + "--" + options.type,
            $2cd9b892908a0c8c$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $2cd9b892908a0c8c$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $2cd9b892908a0c8c$export$93b21159ad85c843 + "--nav",
            $2cd9b892908a0c8c$export$72d36ecf3758cb4b,
            !this.config.hidden && $2cd9b892908a0c8c$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $2cd9b892908a0c8c$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $2cd9b892908a0c8c$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $2cd9b892908a0c8c$var$forOwn(styles, function(value, key) {
            style += " " + $2cd9b892908a0c8c$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$2cd9b892908a0c8c$var$push(slides, slides);
        $2cd9b892908a0c8c$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $2cd9b892908a0c8c$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $2cd9b892908a0c8c$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $2cd9b892908a0c8c$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $2cd9b892908a0c8c$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $2cd9b892908a0c8c$var$SIZE + " " + $2cd9b892908a0c8c$var$SIZE + "\" width=\"" + $2cd9b892908a0c8c$var$SIZE + "\" height=\"" + $2cd9b892908a0c8c$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $2cd9b892908a0c8c$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


const $58338f3c829582fe$var$htmlEl = document.querySelector('html');
const $58338f3c829582fe$var$buttonEl = document.querySelector('.js-container');
$58338f3c829582fe$var$buttonEl.addEventListener('click', $58338f3c829582fe$var$onClickButton2);
function $58338f3c829582fe$var$onClickButton2(e) {
    console.log(e.target.textContent);
    if (e.target.classList.contains('en')) {
        $58338f3c829582fe$var$htmlEl.setAttribute('lang', 'en');
        console.log("\u041F\u0440\u0438\u0432\u0456\u0442");
    } else if (e.target.classList.contains('pl')) $58338f3c829582fe$var$htmlEl.setAttribute('lang', 'pl');
    else if (e.target.classList.contains('ua')) $58338f3c829582fe$var$htmlEl.setAttribute('lang', 'ua');
    else if (e.target.classList.contains('ru')) $58338f3c829582fe$var$htmlEl.setAttribute('lang', 'ru');
    return;
}
const $58338f3c829582fe$var$homeTexts = {
    // header_logo: {
    //   ua: 'Брокер Yurii Bukhtii',
    //   ru: 'Брокер Yurii Bukhtii',
    //   pl: 'Agent Yurii Bukhtii',
    //   en: 'Broker Yurii Bukhtii',
    // },
    'header_banner-button-1': {
        ua: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zostaw pro\u015Bb\u0119",
        en: 'Leave a request'
    },
    'header_banner-link-1': {
        ua: "\u041F\u043E\u0434\u0437\u0432\u043E\u043D\u0438\u0442\u0438",
        ru: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        pl: "Dzwoni\u0107",
        en: 'Call'
    },
    service_title: {
        ua: "\u042F \u0437\u0430\u0439\u043C\u0430\u044E\u0441\u044C \u043F\u043E\u0448\u0443\u043A\u043E\u043C \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u0438\u0445 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0456\u0432 \u043E\u0440\u0435\u043D\u0434\u0438 \u043E\u0444\u0456\u0441\u0456\u0432",
        ru: "\u042F \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0441\u044C \u043F\u043E\u0438\u0441\u043A\u043E\u043C \u043B\u0443\u0447\u0448\u0438\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u0430\u0440\u0435\u043D\u0434\u044B \u043E\u0444\u0438\u0441\u043E\u0432",
        pl: 'Szukam najlepszych opcji wynajmu biur',
        en: 'I am looking for the best options for renting offices'
    },
    'service_title-1': {
        ua: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043E\u0444\u0456\u0441\u0443 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0456",
        ru: "\u0410\u0440\u0435\u043D\u0434\u0430 \u043E\u0444\u0438\u0441\u0430 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0435",
        pl: 'Wynajem biura w Warszawie',
        en: 'Office rental in Warsaw'
    },
    'service_desc-1-1': {
        ua: "\u0414\u043B\u044F \u0412\u0430\u0441 \u044F \u0437\u043D\u0430\u0439\u0434\u0443 \u043E\u0444\u0456\u0441 \u0432 \u0440\u0456\u0437\u043D\u0438\u0445 \u0440\u0430\u0439\u043E\u043D\u0430\u0445 \u0412\u0430\u0440\u0448\u0430\u0432\u0438",
        ru: "\u0414\u043B\u044F \u0412\u0430\u0441 \u044F \u043D\u0430\u0439\u0434\u0443 \u043E\u0444\u0438\u0441 \u0432 \u0440\u0430\u0437\u043D\u044B\u0445 \u0440\u0430\u0439\u043E\u043D\u0430\u0445 \u0412\u0430\u0440\u0448\u0430\u0432\u044B",
        pl: "Znajd\u0119 dla Ciebie biuro w r\xf3\u017Cnych dzielnicach Warszawy",
        en: 'I will find an office for you in different districts of Warsaw'
    },
    'service_desc-1-2': {
        ua: "\u041E\u0444\u0456\u0441 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u044F\u043A \u0433\u043E\u0442\u043E\u0432\u0438\u0439 \u043C\u0435\u0431\u043B\u044C\u043E\u0432\u0430\u043D\u0438\u0439, \u0442\u0430\u043A \u0456 \u0441\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0433\u0456\u0434\u043D\u043E \u0412\u0430\u0448\u0438\u0445 \u043F\u043E\u0431\u0430\u0436\u0430\u043D\u044C",
        ru: "\u041E\u0444\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043A\u0430\u043A \u0433\u043E\u0442\u043E\u0432 \u043C\u0435\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u043D, \u0442\u0430\u043A \u0438 \u0441\u043F\u0440\u043E\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0412\u0430\u0448\u0438\u043C \u043F\u043E\u0436\u0435\u043B\u0430\u043D\u0438\u044F\u043C",
        pl: "Biuro mo\u017Ce by\u0107 w pe\u0142ni umeblowane lub zaprojektowane wed\u0142ug Pa\u0144stwa \u017Cycze\u0144.",
        en: 'The office can be either fully furnished or designed according to your wishes'
    },
    'service_desc-1-3': {
        ua: "\u041C\u0435\u0442\u0440\u0430\u0436 \u0432\u0456\u0434 100 \u0434\u043E 3000 \u043C\u043A\u0432",
        ru: "\u041C\u0435\u0442\u0440\u0430\u0436 \u043E\u0442 100 \u0434\u043E 3000 \u043C\u043A\u0432",
        pl: 'Powierzchnia od 100 do 3000 mkw',
        en: 'Area from 100 to 3000 sq m'
    },
    'service_desc-1-4': {
        ua: "*\u041F\u043E\u0441\u043B\u0443\u0433\u0430 \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0430 \u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u0440\u0438\u0445\u043E\u0432\u0430\u043D\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439",
        ru: "*\u0423\u0441\u043B\u0443\u0433\u0430 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430 \u0438 \u043D\u0435\u0442 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439",
        pl: "*Us\u0142uga jest ca\u0142kowicie bezp\u0142atna i nie ma \u017Cadnych ukrytych op\u0142at",
        en: '*The service is completely free and there are no hidden fees'
    },
    'service_btn-1': {
        ua: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zostaw pro\u015Bb\u0119",
        en: 'Leave a request'
    },
    'service_btn-1-2': {
        ua: "\u041F\u043E\u0434\u0437\u0432\u043E\u043D\u0438\u0442\u0438",
        ru: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        pl: "Dzwoni\u0107",
        en: 'Call'
    },
    'service_title-2': {
        ua: "\u0421\u043A\u043B\u0430\u0434 \u0432 \u041F\u043E\u043B\u044C\u0449\u0456",
        ru: "\u0421\u043A\u043B\u0430\u0434 \u0432 \u041F\u043E\u043B\u044C\u0448\u0435",
        pl: 'Magazyn w Polsce',
        en: 'Warehouse in Poland'
    },
    'service_desc-2-1': {
        ua: "\u042F \u0442\u0430\u043A\u043E\u0436 \u0437\u0430\u0439\u043C\u0430\u044E\u0441\u044C \u043E\u0440\u0435\u043D\u0434\u043E\u044E \u0441\u043A\u043B\u0430\u0434\u0456\u0432 \u0432 \u041F\u043E\u043B\u044C\u0449\u0456",
        ru: "\u042F \u0442\u0430\u043A\u0436\u0435 \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0441\u044C \u0430\u0440\u0435\u043D\u0434\u043E\u0439 \u0441\u043A\u043B\u0430\u0434\u043E\u0432 \u0432 \u041F\u043E\u043B\u044C\u0448\u0435",
        pl: "Wynajmuj\u0119 r\xf3wnie\u017C magazyny w Polsce",
        en: 'I also rent warehouses in Poland'
    },
    'service_desc-2-2': {
        ua: "\u0412 \u0434\u043E\u0441\u0442\u0443\u043F\u0456 \u0454 \u0431\u0430\u0437\u0430 \u0432\u043B\u0430\u0441\u043D\u0438\u043A\u0456\u0432/\u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0456\u0432 \u0441\u043A\u043B\u0430\u0434\u0456\u0432 \u0432 \u041F\u043E\u043B\u044C\u0449\u0456 \u0437 \u043E\u0444\u0456\u0446\u0456\u0439\u043D\u0438\u043C\u0438 \u043F\u0440\u0438\u043C\u0456\u0449\u0435\u043D\u043D\u044F\u043C\u0438",
        ru: "\u0412 \u0434\u043E\u0441\u0442\u0443\u043F\u0435 \u0435\u0441\u0442\u044C \u0431\u0430\u0437\u0430 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432/\u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u043E\u0432 \u0441\u043A\u043B\u0430\u0434\u043E\u0432 \u0432 \u041F\u043E\u043B\u044C\u0448\u0435 \u0441 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u043C\u0438",
        pl: "Dost\u0119pna jest baza danych w\u0142a\u015Bcicieli/operator\xf3w magazyn\xf3w w Polsce posiadaj\u0105cych siedziby urz\u0119dowe",
        en: 'A database of warehouse owners/operators in Poland with official premises is available'
    },
    'service_desc-2-3': {
        ua: "\u0414\u043E\u0431\u0440\u0430 \u043F\u043E\u0431\u043B\u0438\u0437\u0443 \u0456\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0456 \u0434\u043E\u0457\u0437\u0434",
        ru: "\u0420\u044F\u0434\u043E\u043C \u043F\u043E\u0431\u043B\u0438\u0437\u043E\u0441\u0442\u0438 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0438 \u0434\u043E\u0435\u0437\u0434",
        pl: "Dobra infrastruktura i dojazd w pobli\u017Cu",
        en: 'Good nearby infrastructure and access'
    },
    'service_desc-2-4': {
        ua: "\u041C\u0435\u0442\u0440\u0430\u0436 \u0432\u0456\u0434 100 \u0434\u043E 3000 \u043C\u043A\u0432",
        ru: "\u041C\u0435\u0442\u0440\u0430\u0436 \u043E\u0442 100 \u0434\u043E 3000 \u043C\u043A\u0432",
        pl: 'Powierzchnia od 100 do 3000 mkw',
        en: 'Area from 100 to 3000 sq m'
    },
    'service_desc-2-5': {
        ua: "*\u041F\u043E\u0441\u043B\u0443\u0433\u0430 \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0430 \u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u0440\u0438\u0445\u043E\u0432\u0430\u043D\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439",
        ru: "*\u0423\u0441\u043B\u0443\u0433\u0430 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430 \u0438 \u043D\u0435\u0442 \u0441\u043A\u0440\u044B\u0442\u044B\u0445 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439",
        pl: "*Us\u0142uga jest ca\u0142kowicie bezp\u0142atna i nie ma \u017Cadnych ukrytych op\u0142at",
        en: '*The service is completely free and there are no hidden fees'
    },
    'service_btn-2': {
        ua: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zostaw pro\u015Bb\u0119",
        en: 'Leave a request'
    },
    'service_btn-2-2': {
        ua: "\u041F\u043E\u0434\u0437\u0432\u043E\u043D\u0438\u0442\u0438",
        ru: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        pl: "Dzwoni\u0107",
        en: 'Call'
    },
    'service_title-3': {
        ua: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u0444\u0456\u0440\u043C\u0438 \u0432 \u041F\u043E\u043B\u044C\u0449\u0456 \u0442\u0430 \u0441\u0443\u043F\u0440\u043E\u0432\u0456\u0434",
        ru: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0444\u0438\u0440\u043C\u044B \u0432 \u041F\u043E\u043B\u044C\u0448\u0435 \u0438 \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0435\u043D\u0438\u0435",
        pl: 'Rejestracja firmy w Polsce i wsparcie',
        en: 'Company registration in Poland and support'
    },
    'service_desc-3-1': {
        ua: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430\u044E \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0444\u0456\u0440\u043C\u0443 \u0432 \u041F\u043E\u043B\u044C\u0449\u0456 \u0437 \u043F\u043E\u0432\u043D\u0438\u043C \u0441\u0443\u043F\u0440\u043E\u0432\u0456\u0434\u043E\u043C",
        ru: "\u041F\u043E\u043C\u043E\u0449\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0444\u0438\u0440\u043C\u0443 \u0432 \u041F\u043E\u043B\u044C\u0448\u0435 \u0441 \u043F\u043E\u043B\u043D\u044B\u043C \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0435\u043D\u0438\u0435\u043C",
        pl: "Pomagam otworzy\u0107 firm\u0119 w Polsce z pe\u0142nym wsparciem",
        en: 'I help you open a company in Poland with full support'
    },
    'service_desc-3-2': {
        ua: "\u041B\u0435\u0433\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0456\u0432 \u0412\u0430\u0448\u043E\u0457 \u0444\u0456\u0440\u043C\u0438",
        ru: "\u041B\u0435\u0433\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u043E\u0432 \u0432\u0430\u0448\u0435\u0439 \u0444\u0438\u0440\u043C\u044B",
        pl: "Legalizacja pracownik\xf3w Twojej firmy",
        en: 'Legalization of your company`s employees'
    },
    'service_desc-3-3': {
        ua: "\u0417\u0432\u0435\u0440\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u044F \u0437 \u0440\u0430\u0434\u0456\u0441\u0442\u044E \u0412\u0430\u043C \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0443",
        ru: "\u041E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u0441 \u0440\u0430\u0434\u043E\u0441\u0442\u044C\u044E \u0412\u0430\u043C \u043F\u043E\u043C\u043E\u0433\u0443",
        pl: "Prosz\u0119 si\u0119 ze mn\u0105 skontaktowa\u0107, ch\u0119tnie pomog\u0119",
        en: 'Please contact me, I will be happy to help you'
    },
    'service_desc-3-4': {
        ua: "*\u041F\u043E\u0441\u043B\u0443\u0433\u0430 \u043F\u043B\u0430\u0442\u043D\u0430",
        ru: "*\u0423\u0441\u043B\u0443\u0433\u0430 \u043F\u043B\u0430\u0442\u043D\u0430\u044F",
        pl: "*Us\u0142uga jest p\u0142atna",
        en: '*Service is paid'
    },
    'service_btn-3': {
        ua: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zostaw pro\u015Bb\u0119",
        en: 'Leave a request'
    },
    'service_btn-3-2': {
        ua: "\u041F\u043E\u0434\u0437\u0432\u043E\u043D\u0438\u0442\u0438",
        ru: "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C",
        pl: "Dzwoni\u0107",
        en: 'Call'
    },
    'my-services_title-2': {
        ua: "5 \u043F\u0440\u0438\u0447\u0438\u043D \u0441\u043F\u0456\u0432\u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438 \u0437\u0456 \u043C\u043D\u043E\u044E",
        ru: "5 \u043F\u0440\u0438\u0447\u0438\u043D \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0430\u0442\u044C \u0441\u043E \u043C\u043D\u043E\u0439",
        pl: "5 powod\xf3w, dla kt\xf3rych warto ze mn\u0105 wsp\xf3\u0142pracowa\u0107",
        en: '5 reasons to work with me'
    },
    'my-services-desc-1': {
        ua: "\u041C\u0430\u0454 \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439 \u0434\u043E\u0441\u0432\u0456\u0434 \u0432 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u0456\u0439 \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u043E\u0441\u0442\u0456",
        ru: "\u0418\u043C\u0435\u044E \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 \u0432 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438",
        pl: "Posiada udane do\u015Bwiadczenie w obrocie nieruchomo\u015Bciami komercyjnymi",
        en: 'Has successful experience in commercial real estate'
    },
    'my-services-desc-2': {
        ua: "\u041F\u0440\u043E\u043F\u043E\u043D\u0443\u044E \u0442\u0456\u043B\u044C\u043A\u0438 \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u0456 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0438",
        ru: "\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u0430\u043C\u044B\u0435 \u043B\u0443\u0447\u0448\u0438\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0430\u0440\u0435\u043D\u0434\u044B",
        pl: "Oferuj\u0119 tylko najlepsze opcje wynajmu",
        en: 'I offer only the best rental options'
    },
    'my-services-desc-3': {
        ua: "\u041C\u043E\u0457 \u043F\u043E\u0441\u043B\u0443\u0433\u0438 \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0456 \u0456 \u044F \u043D\u0435 \u0431\u0435\u0440\u0443 \u043D\u0456\u044F\u043A\u0438\u0445 \u043A\u043E\u043C\u0456\u0441\u0456\u0439",
        ru: "\u041C\u043E\u0438 \u0443\u0441\u043B\u0443\u0433\u0438 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B \u0438 \u044F \u043D\u0435 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u044E \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439",
        pl: "Moje us\u0142ugi s\u0105 bezp\u0142atne i nie pobieram \u017Cadnych prowizji",
        en: 'My services are free and I do not charge any commissions'
    },
    'my-services-desc-4': {
        ua: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430\u044E \u043D\u0430 \u0432\u0441\u0456\u0445 \u0435\u0442\u0430\u043F\u0430\u0445 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443 \u043F\u043E \u043E\u0440\u0435\u043D\u0434\u0456",
        ru: "\u041F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430 \u0432\u0441\u0435\u0445 \u044D\u0442\u0430\u043F\u0430\u0445 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043F\u043E \u0430\u0440\u0435\u043D\u0434\u0435",
        pl: "Pomagam na ka\u017Cdym etapie podpisywania umowy najmu",
        en: 'I help at all stages of signing a lease agreement'
    },
    'my-services-desc-5': {
        ua: "\u0412 \u043C\u0435\u043D\u0435 \u043D\u0430\u0439\u0431\u0456\u043B\u044C\u0448\u0430 \u0431\u0430\u0437\u0430 \u043E\u0440\u0435\u043D\u0434\u0438 \u043E\u0444\u0456\u0441\u0456\u0432 \u0442\u0430 \u0441\u043A\u043B\u0430\u0434\u0456\u0432 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0456",
        ru: "\u0423 \u043C\u0435\u043D\u044F \u0441\u0430\u043C\u0430\u044F \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0431\u0430\u0437\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u043E\u0444\u0438\u0441\u043E\u0432 \u0438 \u0441\u043A\u043B\u0430\u0434\u043E\u0432 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0435",
        pl: "Wyb\xf3r biura do wynaj\u0119cia z indywidualnym remontem dla najemcy",
        en: 'I have the largest base of office and warehouse rentals in Warsaw'
    },
    'advantages_title-2': {
        ua: "\u041C\u043E\u0457 \u043F\u0435\u0440\u0435\u0432\u0430\u0433\u0438",
        ru: "\u041C\u043E\u0438 \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430",
        pl: 'Moje zalety',
        en: 'My advantages'
    },
    'advantages_pre-title-4': {
        ua: "\u0415\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u0430 \u0431\u0430\u0437\u0430 \u043E\u0444\u0456\u0441\u0456\u0432",
        ru: "\u042D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u0430\u044F \u0431\u0430\u0437\u0430 \u043E\u0444\u0438\u0441\u043E\u0432",
        pl: 'Ekskluzywna baza biurowa',
        en: 'Exclusive office base'
    },
    'advantages_pre-title-5': {
        ua: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u043F\u0456\u0434\u0431\u0456\u0440",
        ru: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043E\u0434\u0431\u043E\u0440",
        pl: 'Personal selection',
        en: 'Personal selection'
    },
    'advantages_pre-title-6': {
        ua: "\u0411\u0435\u0437 \u043A\u043E\u043C\u0456\u0441\u0456\u0457 \u0434\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
        ru: "\u0411\u0435\u0437 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438 \u0434\u043B\u044F \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0430",
        pl: "Brak op\u0142at dla najemcy",
        en: 'No fee for the tenant'
    },
    // меню header
    'header_menu-home': {
        ua: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430",
        ru: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        pl: 'Dom',
        en: 'Home'
    },
    'header_menu-service': {
        ua: "\u041F\u043E\u0441\u043B\u0443\u0433\u0438",
        ru: "\u0423\u0441\u043B\u0443\u0433\u0438",
        pl: "Us\u0142ugi",
        en: 'Services'
    },
    'header_menu-advantages': {
        ua: "\u041F\u0435\u0440\u0435\u0432\u0430\u0433\u0438",
        ru: "\u041F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430",
        pl: 'Zalety',
        en: 'Advantages'
    },
    'header_menu-about': {
        ua: "\u041F\u0440\u043E \u043C\u0435\u043D\u0435",
        ru: "\u041E\u0431\u043E \u043C\u043D\u0435",
        pl: 'O mnie',
        en: 'About me'
    },
    'header_menu-contacts': {
        ua: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
        ru: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B",
        pl: 'Kontakty',
        en: 'Contact'
    },
    'header_banner-name': {
        ua: 'Yurii Bukhtii',
        ru: 'Yurii Bukhtii',
        pl: 'Yurii Bukhtii',
        en: 'Yurii Bukhtii'
    },
    'header_banner-pre-title': {
        ua: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043E\u0444\u0456\u0441\u0456\u0432, \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0457 \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u043E\u0441\u0442\u0456 \u0443 \u0412\u0430\u0440\u0448\u0430\u0432\u0456",
        ru: "\u0410\u0440\u0435\u043D\u0434\u0430 \u043E\u0444\u0438\u0441\u043E\u0432, \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0435",
        pl: "Wynajem biur, nieruchomo\u015Bci komercyjnych w Warszawie",
        en: 'Rent of offices, commercial real estate in Warsaw'
    },
    'header_banner-button': {
        ua: "\u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0430 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u044F",
        ru: "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F",
        pl: 'Darmowa konsultacja',
        en: 'Free consultation'
    },
    'header_banner-link': {
        ua: "\u0410\u0431\u043E \u0437\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C +48 735 775 810",
        ru: "\u0418\u043B\u0438 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u043F\u043E \u043D\u043E\u043C\u0435\u0440\u0443 +48 735 775 810",
        pl: "Jestem profesjonalist\u0105, kt\xf3ry wie jak znale\u017A\u0107 idealn\u0105 lokalizacj\u0119",
        en: 'I am a professional who knows how to find the perfect localization'
    },
    about_title: {
        ua: "\u042F \u043F\u0440\u043E\u0444\u0435\u0441\u0456\u043E\u043D\u0430\u043B \u0456 \u0432\u043C\u0456\u044E \u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0438 \u0456\u0434\u0435\u0430\u043B\u044C\u043D\u0443 \u043B\u043E\u043A\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044E",
        ru: "\u042F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B \u0438 \u0443\u043C\u0435\u044E \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u0443\u044E \u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E",
        pl: "Jestem profesjonalist\u0105, kt\xf3ry wie jak znale\u017A\u0107 idealn\u0105 lokalizacj\u0119",
        en: 'I am a professional who knows how to find the perfect localization'
    },
    about_description: {
        ua: "\u041F\u0440\u0438\u0432\u0456\u0442! \u041C\u0435\u043D\u0435 \u0437\u0432\u0430\u0442\u0438 Yurii Bukhtii",
        ru: "\u041F\u0440\u0438\u0432\u0435\u0442! \u041C\u0435\u043D\u044F \u0437\u043E\u0432\u0443\u0442 Yurii Bukhtii",
        pl: "Cze\u015B\u0107! Mam na imi\u0119 Yurii Bukhtii",
        en: 'Hello! My name is Yurii Bukhtii'
    },
    about_description2: {
        ua: "\u042F \u0431\u0440\u043E\u043A\u0435\u0440 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0457 \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u043E\u0441\u0442\u0456 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0456",
        ru: "\u042F \u0431\u0440\u043E\u043A\u0435\u0440 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0435",
        pl: "Jestem po\u015Brednikiem w obrocie nieruchomo\u015Bciami komercyjnymi w Warszawie",
        en: 'I am a commercial real estate broker in Warsaw'
    },
    about_description3: {
        ua: "\u041C\u043E\u044F \u0440\u043E\u0431\u043E\u0442\u0430 \u043F\u043E\u043B\u044F\u0433\u0430\u0454 \u0443 \u0442\u043E\u043C\u0443, \u0449\u043E\u0431 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438 \u0456\u043D\u0432\u0435\u0441\u0442\u043E\u0440\u0430\u043C, \u043F\u0456\u0434\u043F\u0440\u0438\u0454\u043C\u0446\u044F\u043C \u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044F\u043C \u0437\u043D\u0430\u0439\u0442\u0438 \u0456\u0434\u0435\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0444\u0456\u0441 \u0434\u043B\u044F \u0457\u0445\u043D\u044C\u043E\u0457 \u0434\u0456\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456",
        ru: "\u041C\u043E\u044F \u0440\u0430\u0431\u043E\u0442\u0430 \u0437\u0430\u043A\u043B\u044E\u0447\u0430\u0435\u0442\u0441\u044F \u0432 \u0442\u043E\u043C, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043C\u043E\u0447\u044C \u0438\u043D\u0432\u0435\u0441\u0442\u043E\u0440\u0430\u043C, \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044F\u043C \u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u043C \u043D\u0430\u0439\u0442\u0438 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0444\u0438\u0441 \u0434\u043B\u044F \u0438\u0445 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
        pl: "Moim zadaniem jest pomoc inwestorom, przedsi\u0119biorcom i organizacjom w znalezieniu idealnego biura dla ich dzia\u0142alno\u015Bci",
        en: 'My job is to help investors, entrepreneurs and organizations find the perfect office for their business'
    },
    about_description4: {
        ua: "\u042F \u043F\u0440\u043E\u0432\u043E\u0434\u0436\u0443 \u0412\u0430\u0441 \u0447\u0435\u0440\u0435\u0437 \u0446\u0456\u043B\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441 \u043D\u0430\u0439\u043C\u0443 \u043A\u043E\u043C\u0435\u0440\u0446\u0456\u0439\u043D\u043E\u0457 \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u043E\u0441\u0442\u0456 \u0434\u043E \u043F\u0456\u0434\u043F\u0438\u0441\u0443 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443 \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u043E\u0433\u043E \u0434\u043B\u044F \u0412\u0430\u0441 \u043E\u0444\u0456\u0441\u0443",
        ru: "\u042F \u043F\u0440\u043E\u0432\u043E\u0436\u0443 \u0412\u0430\u0441 \u0447\u0435\u0440\u0435\u0437 \u0446\u0435\u043B\u044B\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441 \u043D\u0430\u0439\u043C\u0430 \u043A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0434\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043B\u0443\u0447\u0448\u0435\u0433\u043E \u0434\u043B\u044F \u0412\u0430\u0441 \u043E\u0444\u0438\u0441\u0430",
        pl: "Przeprowadz\u0119 Ci\u0119 przez ca\u0142y proces wynajmu nieruchomo\u015Bci komercyjnej, a\u017C do podpisania umowy na najlepsze dla Ciebie biuro",
        en: '1. I know the market and constantly study Warsaw`s offers and always offer only the most relevant and profitable options'
    },
    about_description5: {
        ua: "\u0412 \u043C\u0435\u043D\u0435 \u0437 \u043A\u043B\u0456\u0454\u043D\u0442\u0430\u043C\u0438 \u043D\u0430\u0434\u0456\u0439\u043D\u0456 \u0442\u0430 \u043F\u0440\u043E\u0437\u043E\u0440\u0456 \u0432\u0456\u0434\u043D\u043E\u0441\u0438\u043D\u0438, \u0442\u0430\u043A\u043E\u0436 \u044F \u043C\u0430\u044E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0432\u0435\u043B\u0438\u043A\u043E\u0457 \u0431\u0430\u0437\u0438 \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u043E\u0441\u0442\u0456 \u0456 \u0446\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u043C\u0435\u043D\u0456 \u0448\u0432\u0438\u0434\u043A\u043E \u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0438 \u043F\u0440\u0438\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0438 \u044F\u043A\u0456 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456 \u043C\u043E\u0457\u043C \u043A\u043B\u0456\u0454\u043D\u0442\u0430\u043C",
        ru: "\u0423 \u043C\u0435\u043D\u044F \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043D\u0430\u0434\u0435\u0436\u043D\u044B\u0435 \u0438 \u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u044B\u0435 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F, \u0442\u0430\u043A\u0436\u0435 \u0443 \u043C\u0435\u043D\u044F \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0431\u043E\u043B\u044C\u0448\u043E\u0439 \u0431\u0430\u0437\u0435 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0438 \u044D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043C\u043D\u0435 \u0431\u044B\u0441\u0442\u0440\u043E \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0430\u0440\u0435\u043D\u0434\u044B \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0443\u0436\u043D\u044B \u043C\u043E\u0438\u043C \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C",
        pl: "Utrzymuj\u0119 rzetelne i przejrzyste relacje z klientami, a tak\u017Ce mam dost\u0119p do obszernej bazy danych nieruchomo\u015Bci, co pozwala mi szybko znale\u017A\u0107 przestrze\u0144 do wynaj\u0119cia, kt\xf3rej potrzebuj\u0105 moi klienci",
        en: 'I have reliable and transparent relationships with my clients, and I also have access to a large real estate database, which allows me to quickly find the rental space my clients need'
    },
    about_description6: {
        ua: "\u041F\u0440\u043E\u0436\u0438\u0432\u0430\u044E \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0456 \u0456 \u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u0438\u0457\u0445\u0430\u0442\u0438 \u0434\u043E \u043C\u0435\u043D\u0435 \u0432 \u043E\u0444\u0456\u0441 \u0430\u0431\u043E \u043C\u0438 \u043C\u043E\u0436\u0435\u043C\u043E \u0437\u0443\u0441\u0442\u0440\u0456\u0442\u0438\u0441\u044F \u0434\u0435 \u0412\u0430\u043C \u0431\u0443\u0434\u0435 \u0437\u0440\u0443\u0447\u043D\u043E\u0438",
        ru: "\u041F\u0440\u043E\u0436\u0438\u0432\u0430\u044E \u0432 \u0412\u0430\u0440\u0448\u0430\u0432\u0435 \u0438 \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u0438\u0435\u0445\u0430\u0442\u044C \u043A\u043E \u043C\u043D\u0435 \u0432 \u043E\u0444\u0438\u0441 \u0438\u043B\u0438 \u043C\u044B \u043C\u043E\u0436\u0435\u043C \u0432\u0441\u0442\u0440\u0435\u0442\u0438\u0442\u044C\u0441\u044F, \u0433\u0434\u0435 \u0412\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u043E\u0431\u043D\u043E",
        pl: "Mieszkam w Warszawie i mo\u017Cesz przyj\u015B\u0107 do mojego biura lub mo\u017Cemy spotka\u0107 si\u0119 w innym dogodnym dla Ciebie miejscu",
        en: 'I live in Warsaw and you can come to my office or we can meet wherever is convenient for you'
    },
    about_description7: {
        ua: "\u042F \u0433\u043E\u0442\u043E\u0432\u0438\u0439 \u0412\u0430\u043C \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438 \u0437\u043D\u0430\u0439\u0442\u0438 \u0456\u0434\u0435\u0430\u043B\u044C\u043D\u0443 \u041B\u043E\u043A\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044E!",
        ru: "\u042F \u0433\u043E\u0442\u043E\u0432 \u043F\u043E\u043C\u043E\u0447\u044C \u0412\u0430\u043C \u043D\u0430\u0439\u0442\u0438 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u0443\u044E \u041B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E!",
        pl: "Ch\u0119tnie pomog\u0119 Ci znale\u017A\u0107 idealn\u0105 lokalizacj\u0119!",
        en: 'I am ready to help you find the perfect Localization!'
    },
    contacts_title: {
        ua: "\u0414\u0437\u0432\u043E\u043D\u0456\u0442\u044C, \u043F\u0438\u0448\u0456\u0442\u044C \u0430\u0431\u043E \u0437\u0430\u043B\u0438\u0448\u0430\u0439\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u0417\u0432\u043E\u043D\u0438\u0442\u0435, \u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0439\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zadzwo\u0144, napisz lub zostaw pro\u015Bb\u0119",
        en: 'Call, write or leave a request'
    },
    contacts_logo: {
        ua: "\u042F \u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u0437\u043D\u0430\u0439\u0434\u0443 \u0434\u043B\u044F \u0412\u0430\u0441 \u043E\u0444\u0456\u0441 \u0432 \u0431\u0443\u0434\u044C-\u044F\u043A\u043E\u043C\u0443 \u0440\u0430\u0439\u043D\u0456 \u0412\u0430\u0440\u0448\u0430\u0432\u0438. \u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0443\u0439\u0442\u0435 \u0430\u0431\u043E \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0443 \u0437\u0432\u043E\u0440\u043E\u0442\u043D\u044C\u043E\u0433\u043E \u0437\u0432`\u044F\u0437\u043A\u0443 \u0447\u0438 \u043F\u0438\u0448\u0456\u0442\u044C \u0432 \u0442\u0435\u043B\u0435\u0433\u0440\u0430\u043C",
        ru: "\u042F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E \u043D\u0430\u0439\u0434\u0443 \u0434\u043B\u044F \u0412\u0430\u0441 \u043E\u0444\u0438\u0441 \u0432 \u043B\u044E\u0431\u043E\u043C \u0440\u0430\u0439\u043E\u043D\u0435 \u0412\u0430\u0440\u0448\u0430\u0432\u044B. \u0417\u0432\u043E\u043D\u0438\u0442\u0435 \u0438\u043B\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0443 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u0438\u043B\u0438 \u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u0442\u0435\u043B\u0435\u0433\u0440\u0430\u043C",
        pl: "Znajd\u0119 dla Ciebie biuro w dowolnej dzielnicy Warszawy za darmo. Zadzwo\u0144, wype\u0142nij formularz kontaktowy lub napisz na Telegramie",
        en: 'I will find an office for you in any district of Warsaw for free. Call or fill out the feedback form or write to Telegram'
    },
    form_title: {
        ua: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zostaw pro\u015Bb\u0119",
        en: 'Leave a request'
    },
    form_name: {
        ua: "\u0406\u043C`\u044F*",
        ru: "\u0418\u043C\u044F*",
        pl: "Imi\u0119*",
        en: 'Name*'
    },
    form_tel: {
        ua: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D*",
        ru: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D*",
        pl: 'Telefon*',
        en: 'Phone*'
    },
    form_comment: {
        ua: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        ru: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
        pl: "Wiadomo\u015B\u0107",
        en: 'Message'
    },
    form_btn: {
        ua: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
        ru: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        pl: "Wys\u0142a\u0107 pytanie",
        en: 'Send an enquiry'
    },
    form_title2: {
        ua: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
        ru: "\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
        pl: "Zostaw pro\u015Bb\u0119",
        en: 'Leave a request'
    },
    form_name2: {
        ua: "\u0406\u043C`\u044F*",
        ru: "\u0418\u043C\u044F*",
        pl: "Imi\u0119*",
        en: 'Name*'
    },
    form_tel2: {
        ua: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D*",
        ru: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D*",
        pl: 'Telefon*',
        en: 'Phone*'
    },
    form_comment2: {
        ua: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        ru: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
        pl: "Wiadomo\u015B\u0107",
        en: 'Message'
    },
    form_btn2: {
        ua: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
        ru: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
        pl: "Wys\u0142a\u0107",
        en: 'Send'
    },
    form_answer1: {
        ua: "\u2705 \u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        ru: "\u2705 \u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.",
        pl: "\u2705 Pytanie wys\u0142ano",
        en: "\u2705 Message sent."
    },
    form_answer12: {
        ua: "\u0417\u0432`\u044F\u0436\u0443\u0441\u044F \u0437 \u0412\u0430\u043C\u0438 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u043E\u0434\u043D\u0456\u0454\u0457 \u0433\u043E\u0434\u0438\u043D\u0438",
        ru: "\u042F \u0441\u0432\u044F\u0436\u0443\u0441\u044C \u0441 \u0412\u0430\u043C\u0438 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0447\u0430\u0441\u0430",
        pl: "Skontaktuj\u0119 si\u0119 z Tob\u0105 w ci\u0105gu godziny",
        en: 'I will contact you within one hour'
    },
    form_answer21: {
        ua: "\u2705 \u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        ru: "\u2705 \u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
        pl: "\u2705 Wiadomo\u015B\u0107 wys\u0142ana",
        en: "\u2705 Message sent"
    },
    form_answer22: {
        ua: "\u0417\u0432`\u044F\u0436\u0443\u0441\u044F \u0437 \u0412\u0430\u043C\u0438 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u043E\u0434\u043D\u0456\u0454\u0457 \u0433\u043E\u0434\u0438\u043D\u0438",
        ru: "\u042F \u0441\u0432\u044F\u0436\u0443\u0441\u044C \u0441 \u0412\u0430\u043C\u0438 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0447\u0430\u0441\u0430",
        pl: "Skontaktuj\u0119 si\u0119 z Tob\u0105 w ci\u0105gu jednej godziny",
        en: 'I will contact You within one hour'
    }
};
// console.log(htmlEl.lang);
// return;
// const langButtons = document.querySelectorAll('[data-btn]');
const $58338f3c829582fe$var$langButtons = document.querySelectorAll('.btn');
const $58338f3c829582fe$var$allLangs = [
    'ua',
    'ru',
    'pl',
    'en'
];
const $58338f3c829582fe$var$currentPathName = window.location.pathname;
let $58338f3c829582fe$var$currentLang = 'ua';
// localStorage.getItem('language') || checkBrowserLang() || 'ua';
let $58338f3c829582fe$var$currentTexts = {};
// Проверка пути страницы сайта
function $58338f3c829582fe$var$checkPagePathName() {
    switch($58338f3c829582fe$var$currentPathName){
        case '/index.html':
            $58338f3c829582fe$var$currentTexts = $58338f3c829582fe$var$homeTexts;
            break;
        // case '/another_page.html':
        //   currentTexts = anotherTexts;
        //   break;
        default:
            $58338f3c829582fe$var$currentTexts = $58338f3c829582fe$var$homeTexts;
            break;
    }
}
$58338f3c829582fe$var$checkPagePathName();
// Изменение языка у текстов
function $58338f3c829582fe$var$changeLang() {
    for(const key in $58338f3c829582fe$var$currentTexts){
        let elem = document.querySelector(`[data-lang=${key}]`);
        if (elem) elem.textContent = $58338f3c829582fe$var$currentTexts[key][$58338f3c829582fe$var$currentLang];
    }
}
$58338f3c829582fe$var$changeLang();
// Вешаем обработчики на каждую кнопку
$58338f3c829582fe$var$langButtons.forEach((btn)=>{
    btn.addEventListener('click', (event)=>{
        if (!event.target.classList.contains('header__btn_active')) {
            $58338f3c829582fe$var$currentLang = event.target.dataset.btn;
            // localStorage.setItem('language', event.target.dataset.btn);
            $58338f3c829582fe$var$resetActiveClass($58338f3c829582fe$var$langButtons, 'header__btn_active');
            btn.classList.add('header__btn_active');
            $58338f3c829582fe$var$changeLang();
        }
    });
});
// Сброс активного класса у переданного массива элементов
function $58338f3c829582fe$var$resetActiveClass(arr, activeClass) {
    arr.forEach((elem)=>{
        elem.classList.remove(activeClass);
    });
}
// Проверка активной кнопки
// function checkActiveLangButton(e) {
//   switch (currentLang) {
//     case 'ua':
//       document.querySelector('[data-btn="ua"]');
//       // .classList.add('header__btn_active');
//       htmlEl.setAttribute('lang', 'ua');
//       break;
//     case 'ru':
//       document.querySelector('[data-btn="ru"]');
//       // .classList.add('header__btn_active');
//       htmlEl.setAttribute('lang', 'ru');
//       break;
//     case 'pl':
//       document.querySelector('[data-btn="pl"]');
//       // .classList.add('header__btn_active');
//       htmlEl.setAttribute('lang', 'pl');
//       break;
//     case 'de':
//       document.querySelector('[data-btn="en"]');
//       // .classList.add('header__btn_active');
//       htmlEl.setAttribute('lang', 'en');
//       break;
//     default:
//       document.querySelector('[data-btn="ua"]');
//       // .classList.add('header__btn_active');
//       htmlEl.setAttribute('lang', 'uk');
//       break;
//   }
// }
// checkActiveLangButton();
// Проверка языка браузера
function $58338f3c829582fe$var$checkBrowserLang() {
    const navLang = navigator.language.slice(0, 2).toLowerCase();
    const result = $58338f3c829582fe$var$allLangs.some((elem)=>{
        return elem === navLang;
    });
    if (result) return navLang;
}
console.log('navigator.language', $58338f3c829582fe$var$checkBrowserLang());


const $0d7ebe86bac0388d$var$refsContainerButton2 = {
    //   containerRef: document.querySelector('.service__list'),
    openModalRef: document.querySelector('.js-button'),
    closeModalBtnRef: document.querySelector('.js-close-modal'),
    backdrop2Ref: document.querySelector('.js-backdrop-2')
};
$0d7ebe86bac0388d$var$refsContainerButton2.openModalRef.addEventListener('click', $0d7ebe86bac0388d$var$onClickButton2);
$0d7ebe86bac0388d$var$refsContainerButton2.closeModalBtnRef.addEventListener('click', $0d7ebe86bac0388d$var$onCloseModal2);
$0d7ebe86bac0388d$var$refsContainerButton2.backdrop2Ref.addEventListener('click', $0d7ebe86bac0388d$var$onBackdropModal2);
function $0d7ebe86bac0388d$var$onClickButton2(e) {
    //   console.log(e);
    //   if (!e.target.classList.contains('js-button')) {
    //     return;
    //   }
    $0d7ebe86bac0388d$var$refsContainerButton2.backdrop2Ref.classList.remove('is-hidden-2');
    window.addEventListener('keydown', $0d7ebe86bac0388d$var$onEscKeyPress2);
    document.body.classList.add('show-modal');
//   refsContainerButton.modalTitle.textContent = e.target.textContent;
}
function $0d7ebe86bac0388d$var$onCloseModal2() {
    $0d7ebe86bac0388d$var$refsContainerButton2.backdrop2Ref.classList.add('is-hidden-2');
    window.removeEventListener('keydown', $0d7ebe86bac0388d$var$onEscKeyPress2);
    document.body.classList.remove('show-modal');
}
function $0d7ebe86bac0388d$var$onBackdropModal2(event) {
    if (event.currentTarget === event.target) $0d7ebe86bac0388d$var$onCloseModal2();
}
function $0d7ebe86bac0388d$var$onEscKeyPress2(event) {
    if (event.code === 'Escape') $0d7ebe86bac0388d$var$onCloseModal2();
}


// скрипт делегування щоб в контенере при натискі на будь яку кнопку відкривилося модалька
const $8a7e756c566dd1ea$var$refsContainerButton = {
    containerEl: document.querySelector('.js-modal'),
    backdrop: document.querySelector('.js-backdrop')
};
$8a7e756c566dd1ea$var$refsContainerButton.containerEl.addEventListener('click', $8a7e756c566dd1ea$var$onClickButton);
function $8a7e756c566dd1ea$var$onClickButton(e) {
    if (!e.target.classList.contains('btn')) return;
    console.log(e.target);
    $8a7e756c566dd1ea$var$onCloseModal();
}
function $8a7e756c566dd1ea$var$onCloseModal() {
    document.body.classList.remove('show-modal');
    $8a7e756c566dd1ea$var$refsContainerButton.backdrop.classList.add('is-hidden');
}


const $5455bb96aaff6247$var$refsContainerButton2 = {
    containerRef: document.querySelector('.service__list'),
    openModalRef: document.querySelector('.js-button'),
    closeModalBtnRef: document.querySelector('.js-close-modal'),
    backdrop2Ref: document.querySelector('.js-backdrop-2')
};
$5455bb96aaff6247$var$refsContainerButton2.containerRef.addEventListener('click', $5455bb96aaff6247$var$onClickButton2);
$5455bb96aaff6247$var$refsContainerButton2.closeModalBtnRef.addEventListener('click', $5455bb96aaff6247$var$onCloseModal2);
$5455bb96aaff6247$var$refsContainerButton2.backdrop2Ref.addEventListener('click', $5455bb96aaff6247$var$onBackdropModal2);
function $5455bb96aaff6247$var$onClickButton2(e) {
    console.log(e);
    if (!e.target.classList.contains('js-button')) return;
    $5455bb96aaff6247$var$refsContainerButton2.backdrop2Ref.classList.remove('is-hidden-2');
    window.addEventListener('keydown', $5455bb96aaff6247$var$onEscKeyPress2);
    document.body.classList.add('show-modal');
}
function $5455bb96aaff6247$var$onCloseModal2() {
    $5455bb96aaff6247$var$refsContainerButton2.backdrop2Ref.classList.add('is-hidden-2');
    window.removeEventListener('keydown', $5455bb96aaff6247$var$onEscKeyPress2);
    document.body.classList.remove('show-modal');
}
function $5455bb96aaff6247$var$onBackdropModal2(event) {
    if (event.currentTarget === event.target) $5455bb96aaff6247$var$onCloseModal2();
}
function $5455bb96aaff6247$var$onEscKeyPress2(event) {
    if (event.code === 'Escape') $5455bb96aaff6247$var$onCloseModal2();
}


// скрол
window.addEventListener('scroll', ()=>{
    let scrollDistance = window.scrollY;
    // Отримуємо всі пункти меню лише один раз
    const navItems = document.querySelectorAll('.nav li');
    document.querySelectorAll('.scroll').forEach((el, i)=>{
        if (el.offsetTop - document.querySelector('.nav').clientHeight <= scrollDistance) {
            // 1. Знімаємо 'active' з усіх посилань
            document.querySelectorAll('.nav a').forEach((link)=>{
                link.classList.remove('active');
            });
            // 2. ДОДАЄМО ПЕРЕВІРКУ: перевіряємо, чи існує відповідний пункт меню
            const targetNavItem = navItems[i];
            if (targetNavItem) // Якщо елемент існує, продовжуємо
            targetNavItem.querySelector('a').classList.add('active');
        }
    });
});


SmoothScroll({
    // Время скролла 400 = 0.4 секунды
    animationTime: 800,
    // Размер шага в пикселях
    stepSize: 75,
    // Дополнительные настройки:
    // Ускорение
    accelerationDelta: 30,
    // Максимальное ускорение
    accelerationMax: 2,
    // Поддержка клавиатуры
    keyboardSupport: true,
    // Шаг скролла стрелками на клавиатуре в пикселях
    arrowScroll: 50,
    // Pulse (less tweakable)
    // ratio of "tail" to "acceleration"
    pulseAlgorithm: true,
    pulseScale: 4,
    pulseNormalize: 1,
    // Поддержка тачпада
    touchpadSupport: true
});


const $38a977dc8f927f05$var$formText1 = document.querySelector('.form__text1');
const $38a977dc8f927f05$var$formBlock1 = document.querySelector('.form_answer1');
const $38a977dc8f927f05$var$formElement = document.getElementById('form1');
if ($38a977dc8f927f05$var$formElement) $38a977dc8f927f05$var$formElement.addEventListener('submit', async function(e) {
    e.preventDefault(); // Зупиняємо перезавантаження
    // 1. Збираємо дані
    const formData = {
        name: this.name.value,
        tel: this.tel.value,
        comment: this.comment.value
    };
    try {
        // 2. Відправляємо на функцію Netlify
        const response = await fetch('/.netlify/functions/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        if (response.ok) {
            // 3. Очищаємо поля
            this.reset();
            // 4. Ваша анімація успіху
            if ($38a977dc8f927f05$var$formText1) $38a977dc8f927f05$var$formText1.classList.add('form__none1');
            if ($38a977dc8f927f05$var$formBlock1) $38a977dc8f927f05$var$formBlock1.classList.add('form_answer-block1');
            console.log("\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E!");
        } else throw new Error("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430");
    } catch (error) {
        console.error("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0438:", error);
        alert("\u041F\u043E\u043C\u0438\u043B\u043A\u0430! \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0431\u043E\u0442\u0430.");
    } finally{
        console.log("\u0417\u0430\u043F\u0438\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E");
    }
});


const $3bc8e92604c1107d$var$formText1 = document.querySelector('.form__text2');
const $3bc8e92604c1107d$var$formBlock1 = document.querySelector('.form_answer2');
const $3bc8e92604c1107d$var$formElement = document.getElementById('form2');
if ($3bc8e92604c1107d$var$formElement) $3bc8e92604c1107d$var$formElement.addEventListener('submit', async function(e) {
    e.preventDefault(); // Зупиняємо перезавантаження
    // 1. Збираємо дані
    const formData = {
        name: this.name.value,
        tel: this.tel.value,
        comment: this.comment.value
    };
    try {
        // 2. Відправляємо на функцію Netlify
        const response = await fetch('/.netlify/functions/send', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        if (response.ok) {
            // 3. Очищаємо поля
            this.reset();
            // 4. Ваша анімація успіху
            if ($3bc8e92604c1107d$var$formText1) $3bc8e92604c1107d$var$formText1.classList.add('form__none2');
            if ($3bc8e92604c1107d$var$formBlock1) $3bc8e92604c1107d$var$formBlock1.classList.add('form_answer-block2');
            console.log("\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E!");
        } else throw new Error("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430");
    } catch (error) {
        console.error("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0438:", error);
        alert("\u041F\u043E\u043C\u0438\u043B\u043A\u0430! \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0431\u043E\u0442\u0430.");
    } finally{
        console.log("\u0417\u0430\u043F\u0438\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E");
    }
});


const $6f40c3a58f594b58$var$stack = [];
const $6f40c3a58f594b58$var$delayFactor = 300;
const $6f40c3a58f594b58$var$options = {
    rootMargin: '0px',
    threshold: 0.2
};
const $6f40c3a58f594b58$var$callback = (entries)=>{
    entries.forEach((entry)=>{
        if (entry.isIntersecting) {
            $6f40c3a58f594b58$var$stack.push(entry.target);
            const delay = ($6f40c3a58f594b58$var$stack.length - 1) * $6f40c3a58f594b58$var$delayFactor;
            entry.target.setAttribute('data-aos-delay', `${delay}`);
            setTimeout(()=>{
                $6f40c3a58f594b58$var$stack.shift();
            }, delay);
        }
    });
};
const $6f40c3a58f594b58$var$observer = new IntersectionObserver($6f40c3a58f594b58$var$callback, $6f40c3a58f594b58$var$options);
const $6f40c3a58f594b58$var$elementsToTrack = document.querySelectorAll('[data-aos]:not([data-aos-delay])');
$6f40c3a58f594b58$var$elementsToTrack.forEach((element)=>{
    $6f40c3a58f594b58$var$observer.observe(element);
});
document.addEventListener('DOMContentLoaded', function() {
    // new Splide('#slider1').mount();
    // new Splide('#slider2').mount();
    // new Splide('#slider3').mount();
    // Ініціалізація Splide відбувається тільки після паузи
    new (0, $2cd9b892908a0c8c$export$24494c7438c070bf)('#slider1').mount();
    new (0, $2cd9b892908a0c8c$export$24494c7438c070bf)('#slider2').mount();
    new (0, $2cd9b892908a0c8c$export$24494c7438c070bf)('#slider3').mount();
});


//# sourceMappingURL=repo.36a15dff.js.map
